import _toArray from "/builds/talkbox/teamwork/teamwork-product-web/node_modules/@babel/runtime/helpers/esm/toArray.js";
import _toConsumableArray from "/builds/talkbox/teamwork/teamwork-product-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/builds/talkbox/teamwork/teamwork-product-web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/builds/talkbox/teamwork/teamwork-product-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/builds/talkbox/teamwork/teamwork-product-web/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87, _templateObject88, _templateObject89, _templateObject90, _templateObject91, _templateObject92, _templateObject93, _templateObject94, _templateObject95, _templateObject96, _templateObject97, _templateObject98, _templateObject99, _templateObject100, _templateObject101, _templateObject102, _templateObject103, _templateObject104, _templateObject105, _templateObject106, _templateObject107, _templateObject108, _templateObject109, _templateObject110, _templateObject111, _templateObject112, _templateObject113, _templateObject114, _templateObject115, _templateObject116, _templateObject117, _templateObject118, _templateObject119, _templateObject120, _templateObject121, _templateObject122, _templateObject123, _templateObject124, _templateObject125, _templateObject126, _templateObject127, _templateObject128, _templateObject129, _templateObject130, _templateObject131, _templateObject132, _templateObject133, _templateObject134, _templateObject135, _templateObject136, _templateObject137, _templateObject138, _templateObject139;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import e, { css as t, keyframes as r } from "styled-components";
import { space as n, color as o, flexbox as a, grid as l, border as i, borderRadius as s, shadow as c, background as p, typography as d, position as m, gridGap as u, gridColumnGap as h, gridRowGap as f, gridColumn as g, gridRow as y, gridAutoFlow as b, gridAutoColumns as $, gridAutoRows as x, gridTemplateColumns as E, gridTemplateRows as k, gridTemplateAreas as w, gridArea as v, buttonStyle as T, layout as C } from "styled-system";
import S from "@styled-system/prop-types";
import { layout as O, inputSizes as z } from "@fuji-ui/theme";
import R, { themeGet as D } from "@styled-system/theme-get";
import N, { useEffect as P, useState as I, useRef as W, createContext as H, useContext as L, cloneElement as M, Children as F } from "react";
import V from "prop-types";
import j, { match as q, isNot as A } from "styled-is";
import { FocusWithin as B } from "react-focus-within";
import { FontAwesomeIcon as U } from "@fortawesome/react-fontawesome";
import { faTimesCircle as _, faAngleDoubleRight as Y, faAngleRight as G, faAngleDown as J, faExclamation as K, faCheckCircle as Z, faTimes as Q, faCaretSquareLeft as X, faCaretSquareRight as ee, faArrowLeft as te, faCloudUploadAlt as re } from "@fortawesome/free-solid-svg-icons";
import { Link as ne } from "react-router-dom";
import { faCalendar as oe, faClock as ae } from "@fortawesome/free-regular-svg-icons";
var le = e.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: 'border-box';\n  min-width: 0;\n  transition: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), D("transitions.box", "none"), n, o, O, a, l, i, s, c, p, d, m);

function ie() {
  return (ie = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

le.displayName = "Box", le.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, S.space), S.color), S.layout), S.flexbox), S.grid), S.border), S.borderRadius), S.shadow), S.background), S.typography), S.position);

var se = function se(e) {
  var t = e.header,
      r = e.contentSpace;
  return N.createElement(le, ie({
    borderRadius: 4,
    boxShadow: "large",
    display: "inline-block",
    backgroundColor: "surface",
    color: "onSurface"
  }, e), t && N.createElement(le, {
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    overflow: "hidden"
  }, t()), e.children && N.createElement(le, {
    p: r,
    height: "100%"
  }, e.children));
};

se.displayName = "Card", se.propTypes = _objectSpread(_objectSpread({}, le.propTypes), {}, {
  header: V.func,
  contentSpace: V.oneOfType([V.oneOf(["xs", "s", "m", "l", "xl"]), V.number])
}), se.defaultProps = {
  contentSpace: "m"
};
var ce = t(["display:-ms-flexbox;display:-webkit-flex;display:flex;"]),
    pe = t(["display:-ms-inline-flexbox;display:-webkit-inline-flex;display:inline-flex;"]),
    de = e(le)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), q("display", "flex")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n  "])), ce), q("display", "inline-flex")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", "\n  "])), pe)),
    me = e(de).attrs(function () {
  return {
    role: "row"
  };
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  flex-direction: row;\n  -webkit-justify-content: ", ";\n  -webkit-align-items: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n"])), function (e) {
  return e.justifyContent || "flex-start";
}, function (e) {
  return e.alignItems || "flex-start";
}, function (e) {
  return e.justifyContent || "flex-start";
}, function (e) {
  return e.alignItems || "stretch";
}),
    ue = e(de).attrs(function () {
  return {
    role: "column"
  };
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  flex-direction: column;\n  -webkit-justify-content: ", ";\n  -webkit-align-items: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n"])), function (e) {
  return e.justifyContent || "flex-start";
}, function (e) {
  return e.alignItems || "flex-start";
}, function (e) {
  return e.justifyContent || "flex-start";
}, function (e) {
  return e.alignItems || "stretch";
});
de.displayName = "Flex", me.displayName = "Row", ue.displayName = "Column", de.propTypes = _objectSpread({}, le.propTypes), de.defaultProps = {
  display: "flex"
}, me.propTypes = de.propTypes, me.defaultProps = de.defaultProps, ue.propTypes = de.propTypes, ue.defaultProps = de.defaultProps;
var he = e(le)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: ", ";\n  transition: all 1s;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (e) {
  return e.display || "grid";
}, u, h, f, g, y, b, $, x, E, k, w, v);
he.displayName = "Grid", he.propTypes = _objectSpread({}, S.grid);

var fe = function fe(e, t) {
  return N.Children.map(e, function (e) {
    return N.isValidElement(e) ? e.type.skeleton ? t(e) : (e.props.children && (e = N.cloneElement(e, {
      children: fe(e.props.children, t)
    })), e) : e;
  });
},
    ge = function ge(e) {
  var t = e.ready;
  return t ? N.createElement(N.Fragment, null, e.children) : fe(e.children, function (e) {
    var t = e.type;
    return N.createElement(t.skeleton, _objectSpread(_objectSpread({}, e.props), {}, {
      "aria-hidden": !0
    }), null);
  });
};

ge.propTypes = {
  ready: V.bool.isRequired,
  children: V.node
}, ge.defaultProps = {
  ready: !1
};

var ye = t(["color:transparent;background:linear-gradient(-90deg,#f0f0f0 0%,#fafafa 50%,#f0f0f0 100%);background-size:400% 400%;animation:pulse 0.8s ease-in-out infinite;border-radius:", ";@keyframes pulse{0%{background-position:0% 0%;}100%{background-position:-135% 0%;}}"], function (e) {
  return e.borderRadius || R("radii.s", "4px");
}),
    be = e(le)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), ye, z),
    $e = function $e(e) {
  return N.createElement(be, e);
};

$e.style = ye, $e.propTypes = _objectSpread(_objectSpread({}, le.propTypes), z.propTypes), $e.defaultProps = {
  width: "14rem",
  height: "1rem"
};

var xe = r(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]),
    Ee = r(["0%,100%{stroke-dashoffset:2.0em;}50%{stroke-dashoffset:0;}50.1%{stroke-dashoffset:4.0em;}"]),
    ke = e.svg(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 1em;\n  height: 1em;\n  animation: ", " 2s linear infinite;\n  circle {\n    width: 100%;\n    height: 100%;\n    fill: none;\n    stroke-width: 2;\n    stroke: ", ";\n    stroke-linecap: round;\n    stroke-dasharray: 2em;\n    stroke-dashoffset: 2em;\n    transform: translate3d(0, 0, 0) translate(0.1em, 0.1em);\n    animation: ", " 4s linear infinite;\n  }\n  ", "\n"])), xe, function (_ref) {
  var e = _ref.color;
  return D("colors." + e, e);
}, Ee, d),
    we = function we(_ref2) {
  var e = _ref2.color,
      t = _ref2.fontSize;
  return N.createElement(ke, {
    color: e,
    fontSize: t
  }, N.createElement("circle", {
    cx: "0.4em",
    cy: "0.4em",
    r: "0.4em"
  }));
};

we.propTypes = {
  color: V.string,
  fontSize: V.string
}, we.defaultProps = {
  color: "currentColor"
};

var ve = function ve() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = arguments.length > 1 ? arguments[1] : undefined;
  var r = Array.isArray(t) ? t : Object.keys(t);
  return Object.keys(e).filter(function (e) {
    return -1 === r.indexOf(e);
  }).reduce(function (t, r) {
    return _objectSpread(_objectSpread({}, t), {}, _defineProperty({}, r, e[r]));
  }, {});
},
    Te = function Te() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = arguments.length > 1 ? arguments[1] : undefined;
  var r = Array.isArray(t) ? t : Object.keys(t);
  return Object.keys(e).filter(function (e) {
    return -1 !== r.indexOf(e);
  }).reduce(function (t, r) {
    return _objectSpread(_objectSpread({}, t), {}, _defineProperty({}, r, e[r]));
  }, {});
},
    Ce = e(le)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  min-width: fit-content;\n  ", "\n  ", "\n  white-space: nowrap;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  outline: none !important;\n  font-family: ", ";\n  font-weight: 600;\n  border-radius: ", ";\n  padding: 0 ", ";\n  transition: ", ";\n  user-select: none;\n  ", "\n  > span {\n    align-self: center;\n    align-items: baseline;\n    flex-wrap: nowrap;\n    margin: 0 ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"])), "", "", D("fonts.body", "sans-serif"), D("radii.m", "4px"), D("space.s", "8px"), D("transitions.button", "none"), function (e) {
  return j("circle")(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      display: flex;\n      width: ", ";\n      min-width: 0;\n      border-radius: 50%;\n    "])), D("inputSizes.".concat(e.size, ".minHeight")));
}, D("space.xs", "4px"), j("isLoading")(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    padding-right: 2.5em;\n  "]))), A("isLoading")(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    :disabled {\n      background-color: #eeeeee;\n      color: #666;\n      opacity: 0.5;\n      &:hover {\n        background-color: #eeeeee !important;\n        opacity: 0.5 !important;\n      }\n      .spinner,\n      .spinner::before,\n      .spinner::after {\n        background-color: #eeeeee;\n      }\n    }\n  "]))), T, z),
    Se = e.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: auto;\n  right: 1.25em;\n  margin: -0.5em;\n  z-index: ", ";\n  visibility: ", ";\n  opacity: ", ";\n  transition: opacity 0.3s;\n  &::before {\n    content: ' ';\n    width: 1em;\n    height: 1em;\n    transform-origin: 0 0;\n    transform: translateZ(0) scale(0.5);\n    backface-visibility: hidden;\n  }\n"])), function (_ref3) {
  var e = _ref3.isLoading;
  return e ? "10" : "-1";
}, function (_ref4) {
  var e = _ref4.isLoading;
  return e ? "visible" : "hidden";
}, function (_ref5) {
  var e = _ref5.isLoading;
  return e ? "1" : "0";
}),
    Oe = function Oe(e) {
  var t = e.variant,
      r = e.type,
      n = e.size,
      o = e.circle,
      a = e.isLoading,
      l = e.disabled,
      i = e.onClick,
      s = Te(e, le.propTypes);
  return N.createElement(Ce, ie({
    as: "button"
  }, s, {
    type: r,
    circle: o,
    disabled: l || a,
    onClick: i,
    isLoading: a,
    variant: t,
    size: n
  }), N.createElement("span", null, e.children), N.createElement(Se, {
    isLoading: a
  }, N.createElement(we, {
    className: "spinner"
  })));
};

Oe.displayName = "Button", Oe.skeleton = function (e) {
  return N.createElement($e, ie({
    width: "96px",
    height: "2rem"
  }, e));
}, Oe.propTypes = {
  children: V.node,
  onClick: V.func,
  size: V.oneOf(["s", "m", "l"]),
  variant: V.oneOf(["primary", "secondary", "danger", "plain", "icon"]),
  circle: V.bool,
  type: V.oneOf(["button", "submit", "reset"]),
  disabled: V.bool,
  isLoading: V.bool
}, Oe.defaultProps = {
  size: "m",
  variant: "primary",
  type: "button",
  isLoading: !1
};

var ze = function ze() {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }

  var t = N.useRef();
  return P(function () {
    e.forEach(function (e) {
      e && ("function" == typeof e ? e(t.current) : e.current = t.current);
    });
  }, [e]), t;
},
    Re = t(["color:", ";opacity:0.36;"], D("colors.onInput", "#000000"));

t(["color:", ";opacity:0.1;"], D("colors.onInput", "#000000"));
var De = e(le)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  position: absolute;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: ", ";\n  z-index: 10;\n  top: 0;\n  bottom: 0;\n  ", "\n"])), "33px", Re);

var Ne = function Ne() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  var _I = I(e),
      _I2 = _slicedToArray(_I, 2),
      r = _I2[0],
      n = _I2[1];

  return [_toConsumableArray(r).sort(), function (e) {
    var o = [].concat(_toConsumableArray(Array.isArray(e) ? e : [e]), _toConsumableArray(r)).splice(0, t);
    return n(o), o;
  }];
},
    Pe = ["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#00bcd4", "#2196f3", "#009688", "#4caf50", "#ff5722", "#795548", "#607d8b"],
    Ie = function Ie(e) {
  if (void 0 !== e) {
    var t = e.split("").reduce(function (e, t) {
      return e + t.charCodeAt(0);
    }, 0);
    return Pe[t % Pe.length];
  }
};

Ie.colors = Pe;

var We = function We(e) {
  var t = document.createEvent("MouseEvents");
  return t.initEvent(e, !0, !0), function (e) {
    return e.dispatchEvent(t);
  };
};

var He;

var Le = function Le() {
  console.log("[useServiceWorker] requestUpdate"), He.update();
},
    Me = function Me(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 864e5;
  P(function () {
    var t;
    console.log("[useServiceWorker]"), e({
      onUpdate: o
    }), t = r, "production" === process.env.NODE_ENV ? "serviceWorker" in navigator ? navigator.serviceWorker.ready.then(function (e) {
      console.log("[useServiceWorker] ready"), He = e, setInterval(Le, t);
    }) : console.warn("Service worker is not supported.") : console.log("[useServiceWorker] not going to run in dev mode");
  }, []);

  var n = function n() {
    var e;
    console.log("[useServiceWorker] performUpdate", He.waiting), null === (e = He.waiting) || void 0 === e || e.postMessage({
      type: "SKIP_WAITING"
    }), window.location.reload(!0);
  },
      o = function o(e) {
    console.log("[serviceworker] onSWUpdate"), null == t || t(n), He = e;
  };
},
    Fe = e(de)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  display: ", ";\n  position: relative;\n  pointer-events: auto;\n  align-items: center;\n  color: ", ";\n  border-style: solid;\n  border-width: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  &:hover {\n    ", ";\n  }\n  ", "\n  ", "\n  ", "\n  > * {\n    transition: ", ";\n  }\n  > input, textarea {\n    flex: 1;\n    width: 100%;\n    outline: none !important;\n    border-style: none;\n    background-color: transparent;\n    padding: 0 ", ";\n    font: inherit;\n    /* for styled-component, separate : with :: */\n    ::placeholder,\n    ::-webkit-input-placeholder {\n      ", "\n    }\n    :-ms-input-placeholder {\n      ", "\n    }\n    &:disabled {\n      cursor: not-allowed;\n    }\n    ", "\n  }\n  > textarea {\n    padding: ", " ", ";\n    min-height: ", ";\n    max-height: ", ";\n  }\n  ", " {\n    pointer-events: none;\n  }\n\n  ", "\n  ", "\n"])), function (e) {
  return e.inline ? "inline-flex" : "flex";
}, D("colors.onInput", "#000000"), D("borderWidths.input", "1px"), D("colors.border", "#000000"), D("radii.m", "4px"), D("colors.input", "#FFFFFF"), A("disabled")(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n      border-color: ", ";\n    "])), D("colors.primary", "blue")), j("focused")(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "])), D("colors.primary", "blue")), j("disabled")(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    cursor: not-allowed;\n    border-color: transparent;\n  "]))), j("error")(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "])), D("colors.error", "red")), D("transitions.input", "none"), D("space.s", "2px"), Re, Re, j("icon")(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n      &:first-of-type {\n        padding-left: ", ";\n      }\n    "])), "33px"), D("space.s"), D("space.s"), function (e) {
  var t;
  return (null === (t = e.multiline) || void 0 === t ? void 0 : t.min) || "110px";
}, function (e) {
  var t;
  return (null === (t = e.multiline) || void 0 === t ? void 0 : t.max) || "auto";
}, De, z, s),
    Ve = e.button(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  padding: 0;\n  color: #c7c7c7;\n  font-size: inherit;\n  &:hover {\n    color: #a9a9a9;\n  }\n  padding: 4px 12px;\n"]))),
    je = ["id", "placeholder", "disabled", "type", "value", "defaultValue"],
    qe = N.forwardRef(function (e, t) {
  var r = e.multiline,
      n = e.icon,
      o = e.onFocus,
      a = e.onBlur,
      l = e.name,
      i = e.onChange,
      s = e.clearable,
      c = e.autoFocus,
      p = e.spellCheck,
      d = W(),
      m = ze(t, d),
      u = _objectSpread(_objectSpread({}, ve(e, [].concat(je, ["onChange", "autoFocus", "spellCheck"]))), {}, {
    disabled: e.disabled,
    error: e.error
  }),
      h = Te(e, je),
      _I3 = I(!1),
      _I4 = _slicedToArray(_I3, 2),
      f = _I4[0],
      g = _I4[1],
      y = e.autoComplete ? "on" : "off",
      b = function b(e) {
    var t = e.target,
        n = e.target.value;
    s && g("" !== n), r && (t.style.height = "auto", t.style.height = t.scrollHeight + "px"), i && i(n);
  },
      $ = function $() {
    m.current.value = "", m.current.focus(), g(!1), i && i("");
  };

  return N.createElement(B, {
    onFocus: o,
    onBlur: a
  }, function (_ref6) {
    var e = _ref6.focusProps,
        t = _ref6.isFocused;
    return N.createElement(Fe, ie({}, u, e, {
      focused: t
    }), n && N.createElement(De, null, n), r ? N.createElement("textarea", ie({
      ref: m,
      name: l
    }, h, {
      autoComplete: y,
      autoFocus: c,
      spellCheck: p,
      onChange: b
    })) : N.createElement("input", ie({
      ref: m,
      name: l
    }, h, {
      autoComplete: y,
      autoFocus: c,
      onChange: b
    })), f && N.createElement(Ve, {
      onClick: $
    }, N.createElement(U, {
      icon: _
    })));
  });
});

qe.displayName = "TextInput", qe.skeleton = e(Fe)(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  ", "\n  border: 0;\n  width: 14rem;\n  color: transparent;\n  &::before {\n    content: 'a';\n  }\n"])), $e.style), qe.propTypes = {
  inline: V.bool,
  multiline: V.oneOfType([V.bool, V.shape({
    min: V.string,
    max: V.string
  })]),
  size: V.oneOf(["s", "m", "l"]),
  placeholder: V.string,
  icon: V.node,
  type: V.string,
  id: V.string,
  name: V.string,
  onFocus: V.func,
  onBlur: V.func,
  onChange: V.func,
  autoComplete: V.bool,
  autoFocus: V.bool,
  spellCheck: V.bool,
  clearable: V.bool,
  disabled: V.bool,
  error: V.bool,
  defaultValue: V.string
}, qe.defaultProps = {
  size: "m",
  type: "text",
  clearable: !1
};
var Ae = e(Fe)(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  input {\n    text-align: center;\n  }\n"]))),
    Be = N.forwardRef(function (e, t) {
  var _ref7 = t || [],
      _ref8 = _slicedToArray(_ref7, 2),
      r = _ref8[0],
      n = _ref8[1],
      o = e.icon,
      a = e.type,
      _e$placeholder = e.placeholder,
      l = _e$placeholder === void 0 ? [] : _e$placeholder,
      _e$disabled = e.disabled,
      i = _e$disabled === void 0 ? [] : _e$disabled,
      _e$name = e.name,
      s = _e$name === void 0 ? [] : _e$name,
      _e$value = e.value,
      c = _e$value === void 0 ? [] : _e$value,
      p = e.error,
      d = e.onFocus,
      m = e.onBlur,
      _l = _slicedToArray(l, 2),
      u = _l[0],
      h = _l[1],
      _i = _slicedToArray(i, 2),
      f = _i[0],
      g = _i[1],
      _s = _slicedToArray(s, 2),
      y = _s[0],
      b = _s[1],
      _c = _slicedToArray(c, 2),
      $ = _c[0],
      x = _c[1],
      E = e.autoComplete ? "on" : "off",
      k = Te(e, de.propTypes);

  return N.createElement(B, {
    onFocus: d,
    onBlur: m
  }, function (_ref9) {
    var e = _ref9.focusProps,
        t = _ref9.isFocused;
    return N.createElement(Ae, ie({
      icon: o
    }, k, e, {
      focused: t,
      error: p
    }), o && N.createElement(De, null, o), N.createElement("input", {
      ref: r,
      type: a,
      placeholder: u,
      disabled: f,
      name: y,
      value: $,
      autoComplete: E
    }), N.createElement(U, {
      icon: Y,
      color: "#C9C9C9"
    }), N.createElement("input", {
      ref: n,
      type: a,
      placeholder: h,
      disabled: g,
      name: b,
      value: x,
      autoComplete: E
    }));
  });
});
Be.displayName = "TextRangeInput", Be.propTypes = _objectSpread(_objectSpread({}, qe.propTypes), {}, {
  placeholder: V.array,
  disabled: V.array,
  error: V.bool,
  name: V.array,
  value: V.array,
  autoComplete: V.bool
}), Be.defaultProps = _objectSpread({}, qe.defaultProps);
var Ue = e(ne)(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  color: #fff;\n"])));
Ue.displayName = "Link";

var _e = e.img(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  /* change to theme color */\n  background-color: #eee;\n\n  ", "\n\n  ", "\n  ", "\n"])), j("rounded")(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n    border-radius: ", ";\n  "])), D("radii.m", "4px")), O, i),
    Ye = e(le)(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  background-image: ", ";\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n"])), function (e) {
  return "url(".concat(e.src, ")");
});

_e.displayName = "Image", _e.propTypes = _objectSpread(_objectSpread({
  src: V.string.isRequired,
  alt: V.string
}, S.layout), S.border), Ye.propTypes = _objectSpread({
  src: V.string.isRequired
}, le.propTypes), _e.Circular = Ye;

var Ge = function Ge(_ref10) {
  var e = _ref10.width;
  return e ? {
    width: e
  } : {};
},
    Je = function Je(_ref11) {
  var e = _ref11.height;
  return e ? {
    height: e
  } : {};
},
    Ke = function Ke(_ref12) {
  var e = _ref12.width,
      t = _ref12.height,
      r = _ref12.size;
  return r || !e && !t ? function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "m";
    var t = 0,
        r = "16px";

    switch (e) {
      case "xs":
        t = "24px", r = "12px";
        break;

      case "s":
        t = "32px", r = "16px";
        break;

      case "l":
        t = "64px", r = "32px";
        break;

      case "xl":
        t = "80px", r = "36px";
        break;

      case "xxl":
        t = "96px", r = "48px";
        break;

      case "m":
      default:
        t = "48px", r = "24px";
    }

    return {
      width: t,
      height: t,
      fontSize: r
    };
  }(r) : {};
},
    Ze = e(le)(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  display: inline-block;\n  cursor: pointer;\n  border-radius: 50%;\n  border-width: 2px;\n  border-style: solid;\n  border-color: white;\n  text-transform: uppercase;\n"]))),
    Qe = function Qe(e) {
  var t = e.src,
      r = e.name,
      n = e.onClick,
      o = _objectSpread(_objectSpread(_objectSpread({}, Ge(e)), Je(e)), Ke(e)),
      a = Ie(r);

  return N.createElement(Ze, ie({
    as: "a",
    onClick: n
  }, e, {
    bg: a
  }), "" !== t ? N.createElement(_e.Circular, ie({
    src: t
  }, o)) : N.createElement(de, ie({
    justifyContent: "center",
    alignItems: "center",
    color: "white"
  }, o), r[0]));
};

Qe.displayName = "Avatar", Qe.propTypes = _objectSpread(_objectSpread({}, _e.Circular.propTypes), {}, {
  name: V.string.isRequired,
  size: V.oneOf(["xs", "s", "m", "l", "xl", "xxl"]),
  onClick: V.func
}), Qe.defaultProps = {
  name: "Unknown",
  src: "",
  onClick: function onClick() {}
};
var Xe = e.div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), O, n, a);
Xe.displayName = "Spacer", Xe.propTypes = _objectSpread(_objectSpread(_objectSpread({}, S.layout), S.space), S.flexbox);

var et = e(le).attrs(function () {
  return {
    role: "list"
  };
})(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  & + & {\n    margin-top: ", ";\n  }\n"])), D("space.m", "1rem")),
    tt = e.ul(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n"]))),
    rt = e(le)(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  padding: ", " 0;\n  font-size: ", ";\n"])), D("space.s", "0"), D("fontSizes.body", "1rem")),
    nt = rt,
    ot = function ot(e) {
  return N.createElement(et, e, e.header && N.createElement(rt, null, e.header), N.createElement(tt, null, e.children), e.footer && N.createElement(nt, null, e.footer));
};

ot.displayName = "List", ot.propTypes = _objectSpread(_objectSpread({}, le.propTypes), {}, {
  header: V.node,
  footer: V.node,
  children: V.node
});

var at = e.li(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n    padding: ", " 0;\n    font-size: ", ";\n    a {\n      user-select: none;\n    }\n    ", "\n    ", "\n    ", "\n"])), D("space.s", "0"), D("fontSizes.body", "1rem"), n, o, i),
    lt = function lt(e) {
  var t = {};
  return e.bordered && (t.borderBottomStyle = "solid", t.borderBottomWidth = "separator", t.borderColor = "border"), N.createElement(at, ie({}, e, t), e.children);
};

lt.displayName = "ListItem", lt.propTypes = _objectSpread(_objectSpread(_objectSpread({
  children: V.node,
  bordered: V.bool
}, S.space), S.color.propTypes), S.border);

var it = e.a(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  display: block;\n  border-style: none;\n  padding: ", ";\n  ", "\n  ", "\n"])), D("space.s", "4px"), j("selected")(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n    background-color: #F7F7F7;\n  "]))), j("disabled")(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n    opacity: 0.4;\n  "])))),
    st = function st(e) {
  var t = e.children,
      r = e.selected,
      n = e.disabled,
      o = e.onClick,
      a = ve(e, ["onClick", "selected"]);
  return N.createElement(it, {
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    },
    onClick: o,
    selected: r,
    disabled: n
  }, N.createElement(lt, ie({
    p: 0
  }, a), t));
};

st.displayName = "SelectableListItem", st.propTypes = _objectSpread(_objectSpread({}, lt.propTypes), {}, {
  disabled: V.bool,
  onClick: V.func.isRequired
});
var ct = {
  s: "16px",
  m: "18px",
  l: "20px"
},
    pt = e.span(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"])), D("space.s", "0.5rem")),
    dt = e.input.attrs({
  type: "checkbox"
})(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"]))),
    mt = e.svg(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  fill: none;\n  stroke: white;\n  stroke-width: 2px;\n"]))),
    ut = e(le)(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  top: 2px;\n  width: 16px;\n  height: 16px;\n  background: ", ";\n  border-radius: 3px;\n  vertical-align: middle;\n  transition: all 0.2s;\n  ", " {\n    visibility: hidden;\n  }\n  ", ":focus + & {\n    box-shadow: 0 0 0 3px\n      ", ";\n  }\n  ", ":checked + & {\n    background: ", ";\n    ", " {\n      visibility: visible;\n    }\n  }\n"])), D("colors.secondary", "white"), mt, dt, D("colors.primaryLightVariant", "transparent"), dt, D("colors.primary", "blue"), mt),
    ht = e(le)(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  line-height: unset;\n  ", " {\n    width: ", ";\n    height: ", ";\n  }\n  ", "\n  ", "\n"])), ut, function (e) {
  return ct[e.size];
}, function (e) {
  return ct[e.size];
}, j("disabled")(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n    ", ", ", " {\n        opacity: 0.4;\n    }\n  "])), ut, pt), z),
    ft = N.forwardRef(function (e, t) {
  var r = e.id,
      n = e.name,
      o = e.value,
      a = e.onChange,
      l = e.checked,
      i = e.defaultChecked,
      s = e.disabled,
      c = e.children;
  return N.createElement(ht, ie({
    as: "label",
    disabled: s
  }, Te(e, le.propTypes)), N.createElement(dt, {
    ref: t,
    id: r,
    name: n,
    value: o,
    defaultChecked: i,
    checked: l,
    onChange: function onChange(e) {
      a && a(e.target.checked, e);
    },
    disabled: s
  }), N.createElement(ut, null, N.createElement(mt, {
    viewBox: "0 0 24 24"
  }, N.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }))), c && N.createElement(pt, null, c));
});
ft.displayName = "Checkbox", ft.propTypes = {
  children: V.node,
  id: V.string,
  name: V.string,
  value: V.oneOfType([V.string, V.number]),
  checked: V.bool,
  defaultChecked: V.bool,
  disabled: V.bool,
  onChange: V.func
}, ft.defaultProps = {
  disabled: !1
};

var gt = e(me)(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  color: inherit;\n  align-items: center;\n  padding: ", ";\n  border-top: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  :hover {\n    color: ", ";\n    background-color: #fafafa;\n    border-top: 1px solid #eee;\n    border-bottom: 1px solid #eee;\n  }\n  ", "\n"])), D("space.s", "4px"), D("colors.primary", "blue"), j("disabled")(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n    opacity: 0.4;\n    :hover {\n      color: inherit;\n    }\n  "])))),
    yt = function yt(e) {
  var t = e.children,
      _e$selected = e.selected,
      r = _e$selected === void 0 ? !1 : _e$selected,
      n = e.disabled,
      o = e.onClick,
      a = ve(e, ["onClick", "selected"]);
  return N.createElement(gt, {
    as: "a",
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    },
    onClick: function onClick(e) {
      e.preventDefault(), o(e);
    },
    disabled: n
  }, N.createElement(ft, {
    checked: r,
    onChange: function onChange(e, t) {
      return o(t);
    },
    mr: "s"
  }), N.createElement(lt, ie({
    p: "0"
  }, a), t));
};

yt.displayName = "CheckableListItem", yt.propTypes = _objectSpread(_objectSpread({}, lt.propTypes), {}, {
  onClick: V.func.isRequired,
  selected: V.bool,
  disabled: V.bool
}), ot.Item = lt, ot.SelectableItem = st, ot.CheckableItem = yt;

var bt = e(le).attrs({
  role: "tree"
})(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n"]))),
    $t = e(le).attrs({
  role: "tree-node"
})(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n  display: list-item;\n  > ul {\n    margin-left: 1rem;\n  }\n"]))),
    xt = e.span(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n  padding: 0.4rem 0;\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n  > i {\n    text-align: center;\n    width: 32px;\n    margin-right: ", ";\n  }\n  > label {\n    &:first-child {\n      margin-left: calc(32px + ", ");\n    }\n    flex: 1;\n    display: inline-block;\n    cursor: pointer;\n    border-radius: ", ";\n    ", "\n  }\n"])), D("space.s", "4px"), D("space.s", "4px"), D("radii.s", "2px"), j("selected")(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n      color: ", ";\n      font-weight: 700;\n    "])), D("colors.primary", "blue"))),
    Et = function Et(e) {
  return N.createElement(U, ie({
    icon: G
  }, e));
},
    kt = function kt(e) {
  return N.createElement(U, ie({
    icon: J
  }, e));
},
    wt = function wt(e) {
  var t = e.defaultSelectedNode,
      r = e.onSelect,
      _I5 = I(t),
      _I6 = _slicedToArray(_I5, 2),
      n = _I6[0],
      o = _I6[1];

  return N.createElement(le, Te(e, le.propTypes), N.createElement(vt, {
    selectedNode: n,
    setSelected: function setSelected(e) {
      o(e), r && r(e);
    }
  }, e.children));
},
    vt = function vt(e) {
  var t = e.selectedNode,
      r = e.setSelected;
  return N.createElement(bt, {
    as: "ul"
  }, N.Children.map(e.children, function (e) {
    return N.cloneElement(e, {
      selectedNode: t,
      setSelected: r
    });
  }));
},
    Tt = function Tt(_ref13) {
  var e = _ref13.label,
      t = _ref13.expanded,
      r = _ref13.onClick;
  return N.createElement(xt, {
    onClick: r
  }, N.createElement("i", null, t ? N.createElement(kt, null) : N.createElement(Et, null)), N.createElement("label", null, e));
},
    Ct = function Ct(_ref14) {
  var e = _ref14.label,
      t = _ref14.selected,
      r = _ref14.onClick;
  return N.createElement(xt, {
    selected: t,
    onClick: r
  }, N.createElement("label", null, e));
},
    St = function St(e) {
  var t = e.id,
      r = e.children,
      n = e.label,
      o = e.defaultExpanded,
      a = e.onExpand,
      l = e.selectedNode,
      i = e.setSelected,
      _I7 = I(o),
      _I8 = _slicedToArray(_I7, 2),
      s = _I8[0],
      c = _I8[1];

  return N.createElement($t, ie({
    as: "li"
  }, Te(e, le.propTypes)), r ? N.createElement(N.Fragment, null, N.createElement(Tt, {
    label: n,
    expanded: s,
    onClick: function onClick() {
      c(!s), a && a();
    }
  }), s && N.createElement(vt, {
    selectedNode: l,
    setSelected: i
  }, r)) : N.createElement(Ct, {
    label: n,
    selected: l === t,
    onClick: function onClick() {
      return i(t);
    }
  }));
};

wt.displayName = "Tree", St.displayName = "TreeNode", wt.propTypes = {
  children: V.node,
  defaultSelectedNode: V.string,
  onSelect: V.func
}, St.propTypes = {
  id: V.string.isRequired,
  children: V.node,
  label: V.string.isRequired,
  defaultExpanded: V.bool,
  onExpand: V.func,
  selectedNode: V.string,
  setSelected: V.func.isRequired
}, vt.propTypes = {
  selectedNode: V.string,
  setSelected: V.func,
  children: V.node
}, Tt.propTypes = {
  label: V.string.isRequired,
  expanded: V.bool,
  onClick: V.func.isRequired
}, Ct.propTypes = {
  label: V.string.isRequired,
  selected: V.bool,
  onClick: V.func.isRequired
}, wt.Node = St;
var Ot = .95,
    zt = .9,
    Rt = t(["margin-top:2rem;&:first-child{margin-top:0;}margin-bottom:0;"]),
    Dt = t(["margin-top:1rem;margin-bottom:0;"]),
    Nt = e.h1(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  opacity: ", ";\n  line-height: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), D("fonts.heading", "inherit"), D("fontSizes.h1", "2.5rem"), D("fontWeights.heading", "700"), function (e) {
  return e.opacity || Ot;
}, D("lineHeights.heading", "1.25"), Rt, o, n, C, d);
Nt.displayName = "H1";
var Pt = e.h2(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  opacity: ", ";\n  line-height: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), D("fonts.heading", "inherit"), D("fontSizes.h2", "2rem"), D("fontWeights.heading", "700"), function (e) {
  return e.opacity || Ot;
}, D("lineHeights.heading", "1.25"), Rt, o, n, C, d);
Pt.displayName = "H2";
var It = e.h3(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  opacity: ", ";\n  line-height: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), D("fonts.heading", "inherit"), D("fontSizes.h3", "1.5rem"), D("fontWeights.heading", "700"), function (e) {
  return e.opacity || Ot;
}, D("lineHeights.heading", "1.25"), Rt, o, n, C, d);
It.displayName = "H3";
var Wt = e.h4(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  opacity: ", ";\n  line-height: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), D("fonts.heading", "inherit"), D("fontSizes.h4", "1.25rem"), D("fontWeights.heading", "700"), function (e) {
  return e.opacity || Ot;
}, D("lineHeights.heading", "1.25"), Rt, o, n, C, d);
Wt.displayName = "H4";
var Ht = e.h5(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  opacity: ", ";\n  line-height: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), D("fonts.heading", "inherit"), D("fontSizes.h5", "1rem"), D("fontWeights.heading", "700"), function (e) {
  return e.opacity || Ot;
}, D("lineHeights.heading", "1.25"), Rt, o, n, C, d);
Ht.displayName = "H5";
var Lt = e.h6(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  opacity: ", ";\n  line-height: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), D("fonts.heading", "inherit"), D("fontSizes.h6", "1rem"), D("fontWeights.heading", "700"), function (e) {
  return e.opacity || Ot;
}, D("lineHeights.heading", "1.25"), Rt, o, n, C, d);
Lt.displayName = "H6";
var Mt = e.span(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n  display: block;\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  opacity: ", ";\n  line-height: ", ";\n  ", "\n  &:first-child {\n    margin-top: 0;\n  }\n  ", "\n  ", "\n  ", "  \n  ", "\n  ", "\n"])), D("fonts.body", "inherit"), D("fontSizes.body", "1rem"), D("fontWeights.subtitle", "400"), function (e) {
  return e.opacity || Ot;
}, D("lineHeights.subtitle", "1.5"), Dt, o, n, C, d, a);
Mt.displayName = "Subtitle1";
var Ft = e.span(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n  display: block;\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  opacity: ", ";\n  line-height: ", ";\n  ", "\n  &:first-child {\n    margin-top: 0;\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), D("fonts.body", "inherit"), D("fontSizes.body", "1rem"), D("fontWeights.body", "400"), function (e) {
  return e.opacity || Ot;
}, D("lineHeights.subtitle", "1.5"), Dt, o, n, C, d, a);
Ft.displayName = "Subtitle2";
var Vt = e.p(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  opacity: ", ";\n  line-height: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n"])), D("fonts.body", "inherit"), D("fontSizes.body", "1rem"), function (e) {
  return e.opacity || zt;
}, D("lineHeights.body", "1.5"), Dt, o, n, d);
Vt.displayName = "P";
var jt = e.span(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  opacity: ", ";\n  line-height: ", ";\n  ", "\n  ", "\n  ", "\n"])), D("fonts.body", "inherit"), D("fontSizes.body", "1rem"), function (e) {
  return e.opacity || zt;
}, D("lineHeights.body", "1.5"), o, n, d);
jt.displayName = "Span";

var qt = function qt(e, r, n) {
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "a";
  return t(["color:transparent;display:", ";width:", ";height:", ";&::before{content:'", "';}"], e, r, n, o);
};

Nt.skeleton = e.span(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), $e.style, Rt, qt("block", "10rem", "2rem")), Pt.skeleton = e.span(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), $e.style, Rt, qt("block", "10rem", "1.8rem")), It.skeleton = e.span(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), $e.style, Rt, qt("block", "10rem", "1.4rem")), Wt.skeleton = e.span(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), $e.style, Rt, qt("block", "10rem", "1.2rem")), Ht.skeleton = e.span(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), $e.style, Rt, qt("block", "10rem", "1rem")), Lt.skeleton = e.span(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), $e.style, Rt, qt("block", "10rem", "1rem")), Mt.skeleton = e.span(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), $e.style, Dt, qt("block", "6rem", D("fontSizes.body", "1rem"))), Ft.skeleton = e.span(_templateObject67 || (_templateObject67 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), $e.style, Dt, qt("block", "6rem", D("fontSizes.body", "1rem"))), Vt.skeleton = e.span(_templateObject68 || (_templateObject68 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  font-size: 10px;\n  line-height: 1.6;\n"])), $e.style, qt("inline", "100%", "0.75rem", "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley")), jt.skeleton = e(jt)(_templateObject69 || (_templateObject69 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  font-size: 10px;\n  line-height: 1.6;\n"])), $e.style, qt("inline", "100%", "0.75rem", "Lorem Ipsum is simply the best dummy text"));
var At = Object.freeze({
  __proto__: null,
  H1: Nt,
  H2: Pt,
  H3: It,
  H4: Wt,
  H5: Ht,
  H6: Lt,
  Subtitle1: Mt,
  Subtitle2: Ft,
  P: Vt,
  Span: jt
});

var Bt = function Bt(e) {
  return N.createElement(le, ie({
    as: "span"
  }, e), e.children);
};

Bt.displayName = "Span", Bt.skeleton = e(le)(_templateObject70 || (_templateObject70 = _taggedTemplateLiteral(["\n  ", "\n"])), $e.style), Bt.propTypes = {
  children: V.node
};

var Ut = r(["0%{margin-bottom:-20px;opacity:0;}100%{margin-bottom:0;opacity:1;}"]),
    _t = e(se)(_templateObject71 || (_templateObject71 = _taggedTemplateLiteral(["\n  min-width: 240px;\n  z-index: 100;\n  animation: ", ";\n  span.message {\n    font-weight: ", ";\n  }\n  ", "\n  svg {\n    margin-right: 6px;\n  }\n"])), function () {
  return t(["", " 0.1s ease-in"], Ut);
}, D("fonts.body"), q("type", "error")(_templateObject72 || (_templateObject72 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "])), D("colors.error", "red"), D("colors.onError", "white"))),
    Yt = function Yt(e) {
  var t = e.messages;
  return N.createElement(ue, {
    position: "absolute",
    left: "m",
    bottom: "m",
    alignItems: "flex-start"
  }, t.map(function (e) {
    var t = typeof e,
        r = "string" === t || "number" === t ? {
      message: e
    } : e,
        n = {
      type: r.type
    },
        o = r.key,
        a = r.type,
        l = r.title,
        i = r.message,
        s = r.actions;
    return N.createElement(_t, ie({
      key: o,
      mt: "m",
      minWidth: "240px"
    }, n), N.createElement(me, {
      alignItems: "center"
    }, function (e) {
      var t, r;

      switch (e) {
        case "success":
          t = Z, r = "#7cb342";
          break;

        case "error":
          t = K;
          break;

        default:
          t = !1;
      }

      if (t) return N.createElement(U, {
        icon: t,
        color: r
      });
    }(a), N.createElement(le, null, l && N.createElement(At.H5, {
      mb: "s"
    }, l), i && N.createElement("span", {
      className: "message"
    }, i), !!s && N.createElement(me, {
      mt: "m"
    }, s))));
  }));
};

Yt.propTypes = {
  messages: V.arrayOf(V.shape({
    key: V.oneOfType([V.string, V.number]).isRequired,
    type: V.oneOf(["plain", "success", "error", "warning"]),
    title: V.string,
    message: V.string,
    actions: V.arrayOf(V.node)
  }))
};

var Gt = H(null),
    Jt = function Jt(e) {
  var t = e.children,
      r = e.messages,
      _I9 = I([]),
      _I10 = _slicedToArray(_I9, 2),
      n = _I10[0],
      o = _I10[1];

  P(function () {
    r && r.map(function (e) {
      var t = "object" == typeof e ? _objectSpread({}, e) : e.slice(0);
      a(t);
    });
  }, [JSON.stringify(r)]);

  var a = function a(e) {
    var t = function (e) {
      var t = new Date().getTime(),
          r = typeof e;
      return "string" === r || "number" === r ? {
        key: t,
        message: e
      } : _objectSpread({
        key: t
      }, e);
    }(e),
        r = t.key;

    if (o([].concat(_toConsumableArray(n), [t])), !e.static) {
      var _e2 = setTimeout(function () {
        l(r), clearTimeout(_e2);
      }, 3e3);
    }
  },
      l = function l(e) {
    o(e ? function (t) {
      return t.filter(function (t) {
        return t.key !== e;
      });
    } : function (_ref15) {
      var _ref16 = _toArray(_ref15),
          e = _ref16.slice(1);

      return e;
    });
  };

  return N.createElement(Gt.Provider, {
    value: {
      notify: function notify(e) {
        a(e);
      },
      dismiss: function dismiss(e) {
        l(e);
      }
    }
  }, N.createElement(Yt, {
    messages: n
  }), t);
};

Jt.propTypes = {
  children: V.node,
  messages: V.array
};

var Kt = function Kt() {
  return L(Gt);
},
    Zt = e(de)(_templateObject73 || (_templateObject73 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-wrap: ", ";\n  flex-direction: ", ";\n  > * {\n    ", "\n    ", "\n    ", "\n  }\n"])), function (e) {
  return "row-wrap" === e.direction ? "wrap" : "nowrap";
}, function (e) {
  return e.direction;
}, q("direction", "row")(_templateObject74 || (_templateObject74 = _taggedTemplateLiteral(["\n      &:nth-child(n + 2) {\n        margin-left: ", ";\n      }\n    "])), function (e) {
  return D("space." + e.space);
}), q("direction", "row-wrap")(_templateObject75 || (_templateObject75 = _taggedTemplateLiteral(["\n      margin-bottom: ", ";\n      margin-right: ", ";\n    "])), function (e) {
  return D("space." + e.space);
}, function (e) {
  return D("space." + e.space);
}), q("direction", "column")(_templateObject76 || (_templateObject76 = _taggedTemplateLiteral(["\n      margin-bottom: ", ";\n    "])), function (e) {
  return D("space." + e.space);
})),
    Qt = function Qt(e) {
  var t = e.size,
      r = e.children;
  return N.createElement(Zt, e, r && N.Children.map(r, function (e, r) {
    return e ? e.type ? M(e, {
      key: r,
      size: t
    }) : e : null;
  }));
};

Qt.displayName = "InputGroup", Qt.propTypes = _objectSpread(_objectSpread(_objectSpread({}, S.space), z.propTypes), {}, {
  space: V.oneOf(["xs", "s", "m", "l", "xl"]),
  children: V.node,
  direction: V.oneOf(["row", "row-wrap", "column"])
}), Qt.defaultProps = {
  direction: "row",
  space: "s"
};

var Xt = e(se)(_templateObject77 || (_templateObject77 = _taggedTemplateLiteral(["\n  position: absolute;\n  display: block;\n  min-width: 200px;\n  z-index: 999;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_ref17) {
  var e = _ref17.anchor;
  return e.startsWith("bottom") ? "\n    top: 100%;\n  " : "";
}, function (_ref18) {
  var e = _ref18.anchor;
  return e.startsWith("top") ? "\n    bottom: 100%;\n  " : "";
}, function (_ref19) {
  var e = _ref19.anchor;
  return e.endsWith("Bottom") ? "\n    top: 0;\n  " : "";
}, function (_ref20) {
  var e = _ref20.anchor;
  return e.endsWith("Top") ? "\n    bottom: 0;\n  " : "";
}, function (_ref21) {
  var e = _ref21.anchor;
  return e.startsWith("left") ? "\n    right: 100%;\n  " : "";
}, function (_ref22) {
  var e = _ref22.anchor;
  return e.startsWith("right") ? "\n    left: 100%;\n  " : "";
}, function (_ref23) {
  var e = _ref23.anchor;
  return e.endsWith("Left") ? "\n    right: 0;\n  " : "";
}, function (_ref24) {
  var e = _ref24.anchor;
  return e.endsWith("Right") ? "\n    left: 0;\n  " : "";
}, function (_ref25) {
  var e = _ref25.anchor;
  return "bottom" === e || "top" === e ? "\n    left: 50%;\n    transform: translate(-50%, 0);\n  " : "";
}, function (_ref26) {
  var e = _ref26.anchor;
  return "left" === e || "right" === e ? "\n    top: 50%;\n    transform: translate(0, -50%);\n  " : "";
}),
    er = function er(e) {
  var t = e.defaultPopped,
      r = e.menu,
      n = e.size,
      o = e.anchor,
      a = e.onPopped,
      l = e.disabled,
      i = e.contentSpace,
      s = e.popupWidth,
      c = e.popupMargin,
      _I11 = I(t),
      _I12 = _slicedToArray(_I11, 2),
      p = _I12[0],
      d = _I12[1],
      m = W(!1);

  P(function () {
    var e = function e(_e3) {
      if (l) return;
      var t = m.current.contains(_e3.target),
          r = p !== t;
      d(t), a && r && a(t);
    };

    return document.addEventListener("mousedown", e, !1), function () {
      document.removeEventListener("mousedown", e, !1);
    };
  }, [l]);
  var u = {};
  n && (u.size = n);
  var h = Te(e, le.propTypes);
  return N.createElement(le, ie({
    position: "relative",
    display: "inline-block",
    ref: m
  }, h), e.children && F.map(e.children, function (e, t) {
    return M(e, _objectSpread({
      key: t
    }, u));
  }), p && N.createElement(Xt, {
    contentSpace: i,
    width: s,
    margin: c,
    anchor: o
  }, r));
};

er.propTypes = _objectSpread(_objectSpread({}, z.propTypes), {}, {
  children: V.node,
  menu: V.node,
  contentSpace: se.propTypes.contentSpace,
  popupWidth: se.propTypes.width,
  popupMargin: se.propTypes.margin,
  anchor: V.oneOf(["top", "topLeft", "topRight", "bottom", "bottomLeft", "bottomRight", "left", "leftTop", "leftBottom", "right", "rightTop", "rightBottom"]).isRequired,
  defaultPopped: V.bool,
  onPopped: V.func,
  disabled: V.bool
}), er.defaultProps = {
  anchor: "bottom",
  defaultPopped: !1,
  contentSpace: "s"
};

var tr = function tr(e) {
  var t = e.hideCaret,
      r = e.anchor,
      n = e.renderMenu;
  return N.createElement(nr, {
    anchor: r,
    renderMenu: n,
    renderTrigger: function renderTrigger(_ref27) {
      var r = _ref27.setOpened,
          n = _ref27.opened;
      return N.createElement(Oe, ie({}, e, {
        onClick: function onClick() {},
        onFocus: function onFocus() {
          return r(!0);
        },
        onBlur: function onBlur() {
          return r(!1);
        }
      }), e.children, !t && N.createElement(rr, {
        "aria-hidden": !0
      }, N.createElement(U, {
        icon: J,
        rotation: n ? 180 : 0
      })));
    }
  });
},
    rr = e.span.attrs(["aria-hidden"])(_templateObject78 || (_templateObject78 = _taggedTemplateLiteral(["\n  margin-left: 0.6rem;\n  opacity: 0.8;\n  > svg {\n    padding-top: 2px;\n    transition: transform 0.1s;\n  }\n"]))),
    nr = function nr(e) {
  var _I13 = I(!1),
      _I14 = _slicedToArray(_I13, 2),
      t = _I14[0],
      r = _I14[1],
      n = function n(e) {
    r(e);
  };

  return N.createElement(le, {
    onMouseOver: function onMouseOver() {
      return n(!0);
    },
    onMouseLeave: function onMouseLeave() {
      return n(!1);
    }
  }, N.createElement(er, {
    anchor: e.anchor,
    menu: e.renderMenu(),
    popped: t
  }, e.renderTrigger({
    setOpened: r,
    opened: t
  })));
},
    or = function or(e) {
  return N.createElement(ot, null, e.children);
},
    ar = function ar(e) {
  return N.createElement(ot.Item, null, e.children);
},
    lr = function lr(e) {
  return N.createElement(ot.SelectableItem, {
    onClick: e.onClick
  }, e.children);
};

tr.displayName = "Dropdown", or.displayName = "Menu", ar.displayName = "MenuItem", tr.propTypes = _objectSpread(_objectSpread({}, Oe.propTypes), {}, {
  hideCaret: V.bool,
  renderMenu: V.func.isRequired,
  anchor: V.oneOf(["top", "topLeft", "topRight", "bottom", "bottomLeft", "bottomRight"]).isRequired
}), tr.defaultProps = {
  variant: "secondary",
  anchor: "bottomRight",
  size: "m"
}, nr.propTypes = {
  renderTrigger: V.func.isRequired,
  renderMenu: V.func.isRequired,
  anchor: tr.propTypes.anchor
}, or.propTypes = _objectSpread({}, ot.propTypes), ar.propTypes = _objectSpread({}, ot.Item.propTypes), lr.propTypes = _objectSpread({}, ot.SelectableItem.propTypes), tr.Menu = or, tr.MenuItem = ar, tr.SelectableMenuItem = lr;
var ir = e(le).attrs({
  tabIndex: 0
})(_templateObject79 || (_templateObject79 = _taggedTemplateLiteral(["\n  min-width: 120px;\n  width: ", ";\n  outline: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  color: ", ";\n  border-style: solid;\n  border-width: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  padding: 2px ", ";\n  font: inherit;\n  cursor: pointer;\n  user-select: none;\n  &:hover,\n  &:focus {\n    border-color: ", ";\n  }\n  ", "\n  ", "\n  ", "\n  .placeholder {\n    ", "\n  }\n"])), function (e) {
  return e.width || "100%";
}, D("colors.onInput", "#000000"), D("borderWidths.input", "1px"), D("colors.border", "#000000"), D("radii.m", "4px"), D("colors.input", "#FFFFFF"), D("space.s", "2px"), D("colors.primary", "inherit"), j("error")(_templateObject80 || (_templateObject80 = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "])), D("colors.error", "red")), j("disabled")(_templateObject81 || (_templateObject81 = _taggedTemplateLiteral(["\n    cursor: not-allowed;\n    border-color: transparent !important;\n  "]))), z, Re),
    sr = e(ir)(_templateObject82 || (_templateObject82 = _taggedTemplateLiteral(["\n  padding: 1px ", " 1px ", ";\n"])), D("space.s"), D("space.xs")),
    cr = e.span.attrs(["aria-hidden"])(_templateObject83 || (_templateObject83 = _taggedTemplateLiteral(["\n  margin-left: 0.6rem;\n  opacity: 0.8;\n  > svg {\n    padding-top: 2px;\n    transition: transform 0.1s;\n  }\n"]))),
    pr = N.forwardRef(function (e, t) {
  var r = e.opened,
      n = e.hideCaret,
      o = e.onFocus,
      a = e.onBlur,
      l = e.multiple,
      i = e.disabled,
      s = e.error,
      c = Te(e, _objectSpread(_objectSpread({}, le.propTypes), z.propTypes)),
      p = l ? sr : ir;
  return N.createElement(p, ie({}, c, {
    ref: t,
    onFocus: o,
    onBlur: a,
    disabled: i,
    error: s
  }), e.children, !n && N.createElement(cr, {
    "aria-hidden": !0
  }, N.createElement(U, {
    icon: J,
    rotation: r ? 180 : void 0
  })));
});
pr.propTypes = {
  opened: V.bool,
  hideCaret: V.bool,
  children: V.node,
  onFocus: V.func,
  onBlur: V.func,
  multiple: V.bool,
  disabled: V.bool,
  error: V.bool
};
var dr = V.shape({
  label: V.string.isRequired,
  value: V.oneOfType([V.string, V.number]).isRequired
});

var mr = function mr(_ref28) {
  var e = _ref28.value,
      t = _ref28.placeholder;
  return e ? N.createElement("span", null, e.label) : N.createElement("span", {
    className: "placeholder"
  }, t);
};

mr.propTypes = {
  value: dr,
  placeholder: V.string
};

var ur = function ur(e) {
  var t = e.tagId,
      r = e.size,
      n = e.onClickDelete;
  var o = {};

  switch (t && (o.bg = Ie(t.toString())), r) {
    case "s":
      o.p = "xs", o.fontSize = "xxs";
      break;

    case "m":
      o.p = "xs", o.fontSize = "xs";
      break;

    case "l":
      o.p = "s", o.fontSize = "s";
  }

  return N.createElement(Bt, ie({
    display: "inline-block",
    borderRadius: "s",
    fontWeight: "700"
  }, o, ve(e, ["onClickDelete", "tagId"])), e.children, n && N.createElement(le, {
    display: "inline-block",
    px: "xs",
    ml: "xs",
    onClick: function onClick() {
      return n(t);
    }
  }, N.createElement(U, {
    icon: Q
  })));
},
    hr = e(le)(_templateObject84 || (_templateObject84 = _taggedTemplateLiteral(["\n  span {\n    margin-left: ", ";\n  }\n"])), R("space.xs", "2px"));

ur.propTypes = {
  children: V.node,
  color: V.string,
  bg: V.string,
  tagId: V.oneOfType([V.string, V.number]),
  size: V.oneOf(["s", "m", "l"]),
  onClickDelete: V.func
}, ur.defaultProps = {
  bg: "secondary",
  size: "m"
};

var fr = e.input.attrs({
  type: "text"
})(_templateObject85 || (_templateObject85 = _taggedTemplateLiteral(["\n  flex: 1;\n  min-width: 60px;\n  background: transparent;\n  border: 0;\n  outline: none;\n  font: inherit;\n  margin-left: ", ";\n"])), D("space.xs", "2px")),
    gr = function gr(e) {
  return N.createElement(ur, ie({}, e, {
    bg: "primary",
    color: "onPrimary",
    mx: "2px",
    my: "1px",
    alignSelf: "stretch"
  }));
},
    yr = function yr(e) {
  var _e$values = e.values,
      t = _e$values === void 0 ? [] : _e$values,
      r = e.placeholder,
      n = e.text,
      o = e.size,
      a = e.onDeleteValue,
      l = e.onTextChange,
      i = 0 === t.length,
      s = function s(e) {
    a && a(e);
  };

  return N.createElement(me, {
    flexWrap: "wrap",
    width: "100%"
  }, null == t ? void 0 : t.map(function (e) {
    return N.createElement(gr, {
      size: o,
      tagId: e.value,
      key: e.value,
      onClickDelete: s
    }, e.label);
  }), N.createElement(fr, {
    placeholder: i ? r : void 0,
    onChange: l,
    value: n
  }));
};

function br(e) {
  return null == e || /^[sbn]/.test(typeof e);
}

function $r(e) {
  var t = N.useRef();
  return function e(t, r) {
    var n, o;
    if (t === r) return !0;

    if (t && r && (n = t.constructor) === r.constructor) {
      if (n === Date) return t.getTime() === r.getTime();
      if (n === RegExp) return t.toString() === r.toString();

      if (n === Array && (o = t.length) === r.length) {
        for (; o-- && e(t[o], r[o]);) {
          ;
        }

        return -1 === o;
      }

      if (n === Object) {
        if (Object.keys(t).length !== Object.keys(r).length) return !1;

        for (o in t) {
          if (!(o in r) || !e(t[o], r[o])) return !1;
        }

        return !0;
      }
    }

    return t != t && r != r;
  }(e, t.current) || (t.current = e), t.current;
}

function xr(e, t) {
  "production" !== process.env.NODE_ENV && function (e) {
    if (!e || !e.length) throw new Error("useDeepCompareEffect should not be used with no dependencies. Use React.useEffect instead.");
    if (e.every(br)) throw new Error("useDeepCompareEffect should not be used with dependencies that are all primitive values. Use React.useEffect instead.");
  }(t), N.useEffect(e, $r(t));
}

yr.propTypes = {
  size: V.oneOf(["s", "m", "l"]),
  values: V.arrayOf(dr),
  placeholder: V.string,
  text: V.string,
  onDeleteValue: V.func,
  onTextChange: V.func
};

var Er = function Er(e) {
  var t = e.props.label || e.props.children;
  "string" != typeof t && (t = e.props.value);
  return {
    label: t,
    value: e.props.value
  };
},
    kr = function kr() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var t = arguments.length > 1 ? arguments[1] : undefined;
  return F.toArray(t).reduce(function (t, r) {
    if (N.isValidElement(r)) {
      if (e.indexOf(r.props.value) >= 0) {
        var _Er = Er(r),
            _e4 = _Er.label,
            _n2 = _Er.value;

        return [].concat(_toConsumableArray(t), [{
          label: _e4,
          value: _n2
        }]);
      }

      return r.props.children ? [].concat(_toConsumableArray(t), _toConsumableArray(kr(e, r.props.children))) : t;
    }

    return t;
  }, []);
},
    wr = function wr(e, t) {
  var r = (n = e) ? Array.isArray(n) ? n : [n] : [];
  var n, o;
  return r.length > 0 ? (null === (o = r[0]) || void 0 === o ? void 0 : o.value) ? r : kr(r, t) : r;
},
    vr = function vr(e) {
  var t = e.hideCaret,
      r = e.placeholder,
      n = e.popupWidth,
      o = e.popupMaxHeight,
      a = e.onChange,
      l = e.anchor,
      i = e.multiple,
      s = e.size,
      c = e.disabled,
      p = e.error,
      d = We("mousedown"),
      m = wr(e.defaultValue, e.children),
      _I15 = I(m),
      _I16 = _slicedToArray(_I15, 2),
      u = _I16[0],
      h = _I16[1],
      _I17 = I(!1),
      _I18 = _slicedToArray(_I17, 2),
      f = _I18[0],
      g = _I18[1],
      _I19 = I(""),
      _I20 = _slicedToArray(_I19, 2),
      y = _I20[0],
      b = _I20[1],
      $ = W(null);

  xr(function () {
    var t = wr(e.value, e.children);
    e.value && h(t);
  }, [e.value, e.children]);

  var x = function x(e) {
    var t = u.filter(function (t) {
      return t.value !== e;
    });
    h(t), a && a(t.map(function (e) {
      return e.value;
    }), t);
  },
      E = i ? function (e, t) {
    void 0 !== u.find(function (e) {
      return e.value === t;
    }) ? x(t) : function (e, t) {
      var r = [].concat(_toConsumableArray(u), [{
        label: e,
        value: t
      }]);
      h(r), b(""), a && a(r.map(function (e) {
        return e.value;
      }), r);
    }(e, t);
  } : function (e, t) {
    h([{
      label: e,
      value: t
    }]), a && a(t, {
      label: e,
      value: t
    }), $.current.blur(), d(document.firstChild);
  },
      k = (w = e.children, v = u, T = y, F.toArray(w).filter(function (e) {
    if (N.isValidElement(e)) {
      var _Er2 = Er(e),
          _Er2$label = _Er2.label,
          _t2 = _Er2$label === void 0 ? "" : _Er2$label,
          _Er2$value = _Er2.value,
          _r2 = _Er2$value === void 0 ? "" : _Er2$value;

      return _t2.toLowerCase().indexOf(T.toLowerCase()) >= 0 || _r2.toString().toLowerCase().indexOf(T.toLowerCase()) >= 0;
    }

    return !1;
  }).map(function (e) {
    return v.find(function (t) {
      return t.value === e.props.value;
    }) ? M(e, {
      selected: !0
    }) : e;
  }));

  var w, v, T;
  var C = Te(e, le.propTypes);
  return N.createElement(er, ie({}, C, {
    contentSpace: 0,
    anchor: l,
    popped: f,
    disabled: c,
    popupWidth: n,
    menu: N.createElement(Tr, {
      popupMaxHeight: o
    }, k.length > 0 ? k.map(function (e) {
      return N.isValidElement(e) ? M(e, {
        onSelect: E,
        checkable: i
      }) : e;
    }) : N.createElement(ot.Item, {
      p: "s",
      color: "#CCCCCC"
    }, "No results"))
  }), N.createElement(pr, {
    ref: $,
    onFocus: function onFocus() {
      return g(!c);
    },
    onBlur: function onBlur() {
      return g(!1);
    },
    opened: f,
    hideCaret: t,
    multiple: i,
    disabled: c,
    error: p
  }, i ? N.createElement(yr, {
    size: s,
    values: u,
    placeholder: r,
    onDeleteValue: x,
    text: y,
    onTextChange: function onTextChange(e) {
      var t = e.target.value;
      b(t);
    }
  }) : N.createElement(mr, {
    value: null == u ? void 0 : u[0],
    placeholder: r
  })));
},
    Tr = function Tr(e) {
  return N.createElement(le, {
    maxHeight: e.popupMaxHeight,
    overflowY: "auto"
  }, N.createElement(ot, null, e.children));
},
    Cr = function Cr(_ref29) {
  var e = _ref29.label,
      t = _ref29.value,
      r = _ref29.selected,
      n = _ref29.onSelect,
      o = _ref29.checkable,
      a = _ref29.disabled,
      l = _ref29.children;
  var i = e || ("string" == typeof l ? l : t),
      s = o ? ot.CheckableItem : ot.SelectableItem;
  return N.createElement(s, {
    onClick: function onClick() {
      a || n(i, t);
    },
    selected: r,
    disabled: a
  }, l);
};

vr.displayName = "Select", vr.skeleton = function (e) {
  return N.createElement($e, ie({
    width: "10rem"
  }, e));
}, Tr.displayName = "OptionMenu", Cr.displayName = "OptionMenuItem";
var Sr = V.oneOfType([V.oneOfType([V.string, V.number, dr]), V.arrayOf(V.oneOfType([V.string, V.number, dr]))]);
vr.propTypes = _objectSpread(_objectSpread(_objectSpread({}, z.propTypes), le.propTypes), {}, {
  defaultValue: Sr,
  value: Sr,
  onChange: V.func,
  placeholder: V.string,
  hideCaret: V.bool,
  anchor: V.oneOf(["top", "topLeft", "topRight", "bottom", "bottomLeft", "bottomRight"]).isRequired,
  popupWidth: le.propTypes.maxWidth,
  popupMaxHeight: le.propTypes.maxHeight,
  multiple: V.bool,
  disabled: V.bool,
  error: V.bool
}), vr.defaultProps = {
  anchor: "bottomRight",
  placeholder: "Select",
  size: "m",
  popupWidth: "100%",
  popupMaxHeight: "240px"
}, Tr.propTypes = {
  children: V.node.isRequired,
  popupMaxHeight: le.propTypes.maxHeight
}, Cr.propTypes = {
  label: V.string,
  value: V.oneOfType([V.string, V.number]).isRequired,
  selected: V.bool,
  onSelect: V.func,
  children: V.node.isRequired,
  checkable: V.bool,
  disabled: V.bool
}, vr.Option = Cr;
var Or = {
  s: "16px",
  m: "18px",
  l: "20px"
},
    zr = e.span(_templateObject86 || (_templateObject86 = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"])), D("space.s", "0.5rem")),
    Rr = e.input.attrs({
  type: "radio"
})(_templateObject87 || (_templateObject87 = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"]))),
    Dr = e.div(_templateObject88 || (_templateObject88 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  right: 3px;\n  bottom: 3px;\n  border-radius: 50%;\n  background-color: ", ";\n"])), D("colors.primary", "blue")),
    Nr = e(le)(_templateObject89 || (_templateObject89 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  top: 2px;\n  width: 16px;\n  height: 16px;\n  background: ", ";\n  border-radius: 50%;\n  vertical-align: middle;\n  transition: all 0.2s;\n  ", " {\n    visibility: hidden;\n  }\n  ", ":focus + & {\n    box-shadow: 0 0 0 2px\n      ", ";\n  }\n  ", ":checked + & {\n    ", " {\n      visibility: visible;\n    }\n  }\n"])), D("colors.secondary", "white"), Dr, Rr, D("colors.primaryLightVariant", "transparent"), Rr, Dr),
    Pr = e(le)(_templateObject90 || (_templateObject90 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  line-height: unset;\n  ", " {\n    width: ", ";\n    height: ", ";\n  }\n  ", "\n  ", "\n"])), Nr, function (e) {
  return Or[e.size];
}, function (e) {
  return Or[e.size];
}, j("disabled")(_templateObject91 || (_templateObject91 = _taggedTemplateLiteral(["\n    ", ", ", " {\n        opacity: 0.4;\n    }\n  "])), Nr, zr), z),
    Ir = N.forwardRef(function (e, t) {
  var r = e.name,
      n = e.value,
      o = e.onChange,
      a = e.checked,
      l = e.defaultChecked,
      i = e.disabled,
      s = e.children;
  return N.createElement(Pr, ie({
    as: "label",
    disabled: i
  }, Te(e, le.propTypes)), N.createElement(Rr, {
    ref: t,
    name: r,
    value: n,
    defaultChecked: l,
    checked: a,
    onChange: function onChange(e) {
      o && o(e.target.checked, e);
    },
    disabled: i
  }), N.createElement(Nr, null, N.createElement(Dr, null)), s && N.createElement(zr, null, s));
});
Ir.displayName = "Radio", Ir.propTypes = {
  name: V.string,
  children: V.node,
  value: V.oneOfType([V.string, V.number]),
  checked: V.bool,
  defaultChecked: V.bool,
  disabled: V.bool,
  onChange: V.func
}, Ir.defaultProps = {
  disabled: !1
};

var Wr = function Wr(e) {
  var t = e.size,
      r = e.space,
      n = e.direction,
      o = e.children,
      a = e.name,
      l = e.defaultValue,
      i = e.onChange,
      s = e.childRef,
      c = "row" === n ? {
    mr: r,
    mt: r
  } : {
    mt: r
  };
  return N.createElement(de, ie({}, e, {
    display: "inline-flex",
    flexWrap: "wrap",
    flexDirection: n
  }), o && N.Children.map(o, function (e, r) {
    if (e) {
      var _n3 = e.props.value,
          _o = !(!l || l !== _n3) || void 0;

      return e.type ? M(e, _objectSpread(_objectSpread({
        key: r,
        size: t
      }, c), {}, {
        name: a,
        defaultChecked: _o,
        onChange: i,
        ref: s
      })) : e;
    }

    return null;
  }));
};

Wr.displayName = "RadioGroup", Wr.propTypes = _objectSpread(_objectSpread(_objectSpread({}, S.space), z.propTypes), {}, {
  space: V.oneOf(["xs", "s", "m", "l", "xl"]),
  children: V.node,
  direction: V.oneOf(["row", "column"]),
  name: V.string,
  defaultValue: V.oneOfType([V.string, V.number]),
  onChange: V.func,
  childRef: V.func
}), Wr.defaultProps = {
  direction: "row",
  space: "s"
}, Ir.Group = Wr;

var Hr = function Hr() {
  return +new Date().getFullYear();
},
    Lr = function Lr() {
  return +new Date().getMonth() + 1;
},
    Mr = "Mon",
    Fr = "Tue",
    Vr = "Wed",
    jr = "Thu",
    qr = "Fri",
    Ar = "Sat",
    Br = "Sun",
    Ur = {
  January: "Jan",
  February: "Feb",
  March: "Mar",
  April: "Apr",
  May: "May",
  June: "Jun",
  July: "Jul",
  August: "Aug",
  September: "Sep",
  October: "Oct",
  November: "Nov",
  December: "Dec"
},
    _r = function _r(e, t) {
  return ("" + e).padStart(t, "0");
},
    Yr = function Yr(e, t) {
  return 2 === e ? t % 4 == 0 ? 29 : 28 : [4, 6, 9, 11].includes(e) ? 30 : 31;
},
    Gr = function Gr(e) {
  var t = "[object Date]" === Object.prototype.toString.call(e),
      r = e && !Number.isNaN(e.valueOf());
  return t && r;
},
    Jr = function Jr(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  return !(!Gr(e) || !Gr(t)) && +t.getDate() == +e.getDate() && +t.getMonth() == +e.getMonth() && +t.getFullYear() == +e.getFullYear();
},
    Kr = function Kr(_ref30) {
  var _ref31 = _slicedToArray(_ref30, 2),
      e = _ref31[0],
      t = _ref31[1];

  return [t > 1 ? e : e - 1, t > 1 ? t - 1 : 12];
},
    Zr = function Zr(_ref32) {
  var _ref33 = _slicedToArray(_ref32, 2),
      e = _ref33[0],
      t = _ref33[1];

  return [t < 12 ? e : e + 1, t < 12 ? t + 1 : 1];
},
    Qr = function Qr(e) {
  return e.map(function (e) {
    return _r(e, 2);
  }).join("-");
},
    Xr = function Xr(e) {
  return e.split("-").map(function (e) {
    return +e;
  });
},
    en = function en(e, t) {
  var r, n, o;
  (function (e, t) {
    return Date.parse(e) > Date.parse(t);
  })(e, t) ? (r = new Date(t), n = new Date(e)) : (r = new Date(e), n = new Date(t));

  for (var a = [], l = r; l <= n; l.setDate(l.getDate() + 1)) {
    a.push([(o = l).getFullYear(), o.getMonth() + 1, o.getDate()]);
  }

  return a;
},
    tn = function tn(_ref34) {
  var _ref35 = _slicedToArray(_ref34, 2),
      e = _ref35[0],
      t = _ref35[1];

  var r = Yr(t, e),
      n = function (e, t) {
    return +new Date("".concat(t, "-").concat(_r(e, 2), "-01")).getDay() + 1;
  }(t, e) - 1,
      o = 42 - (n + r),
      _Kr = Kr([e, t]),
      _Kr2 = _slicedToArray(_Kr, 2),
      a = _Kr2[0],
      l = _Kr2[1],
      _Zr = Zr([e, t]),
      _Zr2 = _slicedToArray(_Zr, 2),
      i = _Zr2[0],
      s = _Zr2[1],
      c = Yr(l, a);

  return [].concat(_toConsumableArray(_toConsumableArray(new Array(n)).map(function (e, t) {
    return [a, l, t + 1 + (c - n)];
  })), _toConsumableArray(_toConsumableArray(new Array(r)).map(function (r, n) {
    return [e, t, n + 1];
  })), _toConsumableArray(_toConsumableArray(new Array(o)).map(function (e, t) {
    return [i, s, t + 1];
  })));
},
    rn = e(me)(_templateObject92 || (_templateObject92 = _taggedTemplateLiteral(["\n  justify-content: space-between;\n  align-items: center;\n  font-size: 1.1rem;\n  text-align: center;\n  font-weight: bold;\n  text-transform: uppercase;\n"]))),
    nn = function nn() {
  var e = {
    textAlign: "center",
    flex: 1
  };
  return N.createElement(me, {
    justifyContent: "center",
    alignItems: "center",
    height: "2rem"
  }, N.createElement(le, ie({}, e, {
    fontSize: "xs"
  }), Br), N.createElement(le, ie({}, e, {
    fontSize: "xs"
  }), Mr), N.createElement(le, ie({}, e, {
    fontSize: "xs"
  }), Fr), N.createElement(le, ie({}, e, {
    fontSize: "xs"
  }), Vr), N.createElement(le, ie({}, e, {
    fontSize: "xs"
  }), jr), N.createElement(le, ie({}, e, {
    fontSize: "xs"
  }), qr), N.createElement(le, ie({}, e, {
    fontSize: "xs"
  }), Ar));
},
    on = e(de)(_templateObject93 || (_templateObject93 = _taggedTemplateLiteral(["\n  padding: ", ";\n  border-radius: ", ";\n  width: 2.5rem;\n  height: 2.0rem;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  user-select: none;\n  color: ", ";\n  border-style: none;\n  ", "\n  &:hover {\n    color: inherit;\n    border-style: solid;\n    border-width: 3px;\n    border-color:  ", ";\n  }\n  ", "\n  ", "\n  opacity: ", ";\n"])), D("space.xs", "2px"), D("radii.m", "4px"), D("colors.onSurface", "black"), j("isToday")(_templateObject94 || (_templateObject94 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), D("colors.primaryLightVariant", "lightBlue")), D("colors.primaryLightVariant", "#EEE"), j("inRange")(_templateObject95 || (_templateObject95 = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n  "])), D("colors.onSecondary", "black"), D("colors.secondary", "#EEEEEE")), j("selected")(_templateObject96 || (_templateObject96 = _taggedTemplateLiteral(["\n    color: ", " !important;\n    background-color: ", " !important;\n  "])), D("colors.onPrimary", "white"), D("colors.primary", "blue")), function (e) {
  return e.selectable ? 1 : .2;
}),
    an = e(he)(_templateObject97 || (_templateObject97 = _taggedTemplateLiteral(["\n  /* display: inline-grid; */\n  min-height: 0;\n  flex: 1;\n  justify-items: stretch;\n  align-items: stretch;\n  align-content: start;\n  grid-gap: 1px;\n  grid-template-columns: repeat(7, auto);\n  grid-template-rows: repeat(", ", auto);\n"])), 6),
    ln = e(le)(_templateObject98 || (_templateObject98 = _taggedTemplateLiteral(["\n  display: inline-block;\n  background-color: ", ";\n  border-style: ", ";\n  border-width: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  font-size: ", ";\n  padding: ", ";\n"])), D("colors.surface", "white"), function (e) {
  return e.bordered ? "solid" : "none";
}, D("borderWidths.input", "1px"), D("colors.border", "black"), D("radii.m", "3px"), D("fontSizes.s", "1rem"), D("space.s", "4px")),
    sn = function sn(e) {
  var t = e.defaultYearMonth,
      r = e.defaultValue,
      n = e.onSelectDate,
      o = e.rangeSelect,
      a = e.selectedDates,
      l = o ? 2 : 1,
      _Ne = Ne(r, l),
      _Ne2 = _slicedToArray(_Ne, 2),
      i = _Ne2[0],
      s = _Ne2[1],
      _I21 = I(t || [Hr(), Lr()]),
      _I22 = _slicedToArray(_I21, 2),
      c = _I22[0],
      p = _I22[1],
      d = a || i,
      _c2 = _slicedToArray(c, 2),
      m = _c2[0],
      u = _c2[1],
      h = 2 === d.length ? en(Xr(d[0]), Xr(d[1])) : [],
      f = tn(c),
      g = ve(e, ["onSelectDate"]);

  return N.createElement(ln, g, N.createElement(ue, {
    flex: 1
  }, N.createElement(rn, null, N.createElement(Oe, {
    variant: "icon",
    onClick: function onClick() {
      return p(Kr(c));
    }
  }, N.createElement(U, {
    icon: X
  })), (y = u, Object.keys(Ur)[Math.max(0, Math.min(y - 1, 11))]), " ", m, N.createElement(Oe, {
    variant: "icon",
    onClick: function onClick() {
      return p(Zr(c));
    }
  }, N.createElement(U, {
    icon: ee
  }))), N.createElement(nn, null), N.createElement(an, null, f.map(function (e) {
    var _e5 = _slicedToArray(e, 3),
        t = _e5[0],
        r = _e5[1],
        o = _e5[2],
        a = new Date(),
        l = Qr(e),
        i = r === u,
        c = d.reduce(function (e, t) {
      return e || l === t;
    }, !1),
        p = h.reduce(function (t, r) {
      return t || (o = r, (n = e) && o && n[0] === o[0] && n[1] === o[1] && n[2] === o[2]);
      var n, o;
    }, !1),
        m = "".concat(t, "/").concat(r, "/").concat(o);

    return N.createElement(on, {
      key: m,
      as: "a",
      title: m,
      selectable: i,
      selected: c,
      isToday: Jr(a, new Date(l)),
      inRange: p,
      onClick: function onClick() {
        return i && function (e) {
          var t = s(Qr(e));
          n && n(_toConsumableArray(t));
        }(e);
      }
    }, o);
  }))));
  var y;
};

sn.displayName = "Calendar", on.propTypes = {
  selectable: V.bool,
  selected: V.bool,
  inRange: V.bool
}, sn.propTypes = _objectSpread(_objectSpread({}, le.propTypes), {}, {
  bordered: V.bool,
  rangeSelect: V.bool,
  defaultYearMonth: V.array,
  defaultValue: V.array,
  onSelectDate: V.func,
  selectedDates: V.array
}), sn.defaultProps = {
  bordered: !0,
  defaultValue: []
};
var cn = N.forwardRef(function (e, t) {
  var _ref36 = Array.isArray(t) ? t : [t],
      _ref37 = _slicedToArray(_ref36, 2),
      r = _ref37[0],
      n = _ref37[1],
      o = e.defaultValue,
      a = e.name,
      l = e.rangeSelect,
      i = e.onSelectDate,
      s = e.onChange,
      c = e.placeholder,
      p = e.disabled,
      d = e.error,
      m = e.anchor,
      u = e.defaultPopped,
      h = e.onPopped,
      f = W(null),
      g = W(null),
      y = ze(r, f),
      b = ze(n, g),
      $ = l ? 2 : 1,
      _Ne3 = Ne(o, $),
      _Ne4 = _slicedToArray(_Ne3, 2),
      x = _Ne4[0],
      E = _Ne4[1];

  P(function () {
    var _x = _slicedToArray(x, 2),
        e = _x[0],
        t = _x[1];

    e && y && (y.current.value = e), t && b && (b.current.value = t);
  }, [x]);

  var k = c || (l ? ["Start date", "End date"] : "Select a date"),
      _x2 = _slicedToArray(x, 2),
      w = _x2[0],
      v = _x2[1],
      T = w ? Xr(w) : [Hr(), Lr()];

  var C = v ? Xr(v) : Zr(T);

  var _T = _slicedToArray(T, 2),
      S = _T[0],
      O = _T[1],
      _C = C,
      _C2 = _slicedToArray(_C, 2),
      R = _C2[0],
      D = _C2[1];

  (R[0] <= S[0] || R[0] === S[0] && D[1] <= O[1]) && (C = Zr(C));

  var I = function I(e) {
    var t = E(e[0]);
    s && s(_toConsumableArray(t)), i && i(_toConsumableArray(t));
  },
      H = Te(e, le.propTypes),
      L = Te(e, z.propTypes);

  return N.createElement(er, ie({
    anchor: m,
    defaultPopped: u,
    onPopped: h,
    disabled: p
  }, H, {
    menu: N.createElement(me, null, N.createElement(sn, {
      bordered: !1,
      rangeSelect: l,
      selectedDates: x,
      defaultValue: o,
      onSelectDate: function onSelectDate(e) {
        return I(e);
      },
      defaultYearMonth: T
    }), l && N.createElement(sn, {
      bordered: !1,
      rangeSelect: l,
      selectedDates: x,
      defaultValue: o,
      onSelectDate: function onSelectDate(e) {
        return I(e);
      },
      defaultYearMonth: C
    }))
  }), l ? N.createElement(Be, ie({
    ref: [y, b],
    icon: N.createElement(U, {
      icon: oe
    }),
    placeholder: k,
    disabled: p,
    error: d,
    name: a || ["startDate", "endDate"]
  }, L)) : N.createElement(qe, ie({
    ref: y,
    icon: N.createElement(U, {
      icon: oe
    }),
    placeholder: k,
    disabled: p,
    error: d,
    name: a || "startDate"
  }, L)));
});
cn.displayName = "Datepicker", cn.skeleton = function (e) {
  return N.createElement($e, ie({
    width: "13rem"
  }, e));
}, cn.propTypes = _objectSpread(_objectSpread(_objectSpread({}, le.propTypes), z.propTypes), {}, {
  type: V.oneOf(["date", "datetime"]),
  rangeSelect: V.bool,
  defaultValue: V.array,
  name: V.oneOfType([V.string, V.arrayOf(V.string)]),
  onSelectDate: V.func,
  onChange: V.func,
  placeholder: V.oneOfType([V.string, V.arrayOf(V.string)]),
  disabled: V.oneOfType([V.bool, V.arrayOf(V.bool)]),
  error: V.bool,
  anchor: V.oneOf(["top", "topLeft", "topRight", "bottom", "bottomLeft", "bottomRight"]).isRequired,
  defaultPopped: V.bool,
  onPopped: V.func
}), cn.defaultProps = {
  defaultValue: [],
  anchor: "bottom",
  defaultPopped: !1
};

var pn = e(de)(_templateObject99 || (_templateObject99 = _taggedTemplateLiteral(["\n  padding: ", ";\n  border-radius: ", ";\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  user-select: none;\n  color: ", ";\n  border-color:  ", ";    \n  /* ", " */\n  ", "\n  opacity: ", ";\n"])), D("space.xs", "2px"), D("radii.m", "4px"), D("colors.onSurface", "black"), D("colors.primaryLightVariant", "#EEE"), j("inRange")(_templateObject100 || (_templateObject100 = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";    \n  "])), D("colors.onSecondary", "black"), D("colors.secondary", "#EEEEEE")), j("selected")(_templateObject101 || (_templateObject101 = _taggedTemplateLiteral(["\n    color: ", " !important;\n    background-color: ", " !important;\n  "])), D("colors.onPrimary", "white"), D("colors.primary", "blue")), function (e) {
  return e.disabled ? .2 : 1;
}),
    dn = e(le)(_templateObject102 || (_templateObject102 = _taggedTemplateLiteral(["\n  padding: 2rem 0;\n  min-height: 0;\n  overflow-y: auto;\n  -ms-overflow-style: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n  & + & {\n    border-width: ", ";\n    border-left-style: solid;\n    border-color: ", ";\n  }\n"])), R("borderWidths.separator", "1px"), R("colors.border", "#EEEEEE")),
    mn = e(pn)(_templateObject103 || (_templateObject103 = _taggedTemplateLiteral(["\n  display: block;\n  border: 0;\n"]))),
    un = function un(e) {
  var t = e.selectedItem,
      r = e.onSelect;
  return N.createElement(dn, e, e.data.map(function (e, n) {
    return N.createElement(mn, {
      key: n,
      as: "a",
      onClick: function onClick() {
        return r(e);
      },
      selected: e === t
    }, e);
  }));
};

un.propTypes = {
  data: V.array,
  selectedItem: V.string,
  onSelect: V.func
};

var hn = function hn(e) {
  var _e$trim$split = e.trim().split(" "),
      _e$trim$split2 = _slicedToArray(_e$trim$split, 2),
      t = _e$trim$split2[0],
      r = _e$trim$split2[1],
      _t$split = t.split(":"),
      _t$split2 = _slicedToArray(_t$split, 2),
      n = _t$split2[0],
      o = _t$split2[1];

  return r && n && o ? [n, o, r.toLowerCase()] : [];
},
    fn = function fn(e) {
  var _e6 = _slicedToArray(e, 3),
      t = _e6[0],
      r = _e6[1],
      n = _e6[2];

  return n && t && r ? "".concat(t, ":").concat(r, " ").concat(n.toLowerCase()) : "";
},
    gn = function gn(e) {
  return /^((1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]))$/.test(e);
},
    yn = function yn(e) {
  return /^(([01][0-9])|(2[0-3])):[0-5][0-9]$/.test(e);
},
    bn = function bn(e) {
  if (yn(e)) {
    var _e$trim$split3 = e.trim().split(":"),
        _e$trim$split4 = _slicedToArray(_e$trim$split3, 2),
        _t3 = _e$trim$split4[0],
        _r3 = _e$trim$split4[1];

    return "".concat(+_t3 % 12 || 12, ":").concat(_r3, " ").concat(+_t3 < 12 ? "am" : "pm");
  }

  return e;
};

var $n = Object.freeze({
  __proto__: null,
  timeFromString: hn,
  timeToString: fn,
  is12HFormat: gn,
  is24HFormat: yn,
  convertTimeTo12H: bn,
  convertTimeTo24H: function convertTimeTo24H(e) {
    if (gn(e)) {
      var _hn = hn(e),
          _hn2 = _slicedToArray(_hn, 3),
          _t4 = _hn2[0],
          _r4 = _hn2[1],
          _n4 = _hn2[2];

      return "12" === _t4 && (_t4 = "00"), "pm" === _n4 && (_t4 = (Number(_t4) + 12).toString()), "".concat(_t4.padStart(2, "0"), ":").concat(_r4);
    }

    return e;
  },
  convertTimestampToHourMin: function convertTimestampToHourMin(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

    if (e) {
      var _r5 = new Date(+e),
          _n5 = "".concat(_r5.getHours().toString().padStart(2, "0"), ":").concat(_r5.getMinutes().toString().padStart(2, "0"));

      return t ? _n5 : bn(_n5);
    }

    return null;
  }
});

var xn = ["am", "pm"],
    En = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
    kn = ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"],
    wn = function wn(e) {
  var t = e.onChange,
      _hn3 = hn(e.defaultTime),
      _hn4 = _slicedToArray(_hn3, 3),
      r = _hn4[0],
      n = _hn4[1],
      o = _hn4[2],
      _I23 = I(o),
      _I24 = _slicedToArray(_I23, 2),
      a = _I24[0],
      l = _I24[1],
      _I25 = I(r),
      _I26 = _slicedToArray(_I25, 2),
      i = _I26[0],
      s = _I26[1],
      _I27 = I(n),
      _I28 = _slicedToArray(_I27, 2),
      c = _I28[0],
      p = _I28[1];

  return N.createElement(me, ie({}, e, {
    flex: 1,
    height: "220px",
    alignItems: "stretch"
  }), N.createElement(me, {
    flex: 1
  }, N.createElement(un, {
    flex: 1,
    data: xn,
    onSelect: function onSelect(e) {
      l(e), t && t(fn([i, c, e]));
    },
    selectedItem: a
  }), N.createElement(un, {
    flex: 1,
    data: En,
    onSelect: function onSelect(e) {
      s(e), t && t(fn([e, c, a]));
    },
    selectedItem: i
  }), N.createElement(un, {
    flex: 1,
    data: kn,
    onSelect: function onSelect(e) {
      p(e), t && t(fn([i, e, a]));
    },
    selectedItem: c
  })));
};

wn.propTypes = _objectSpread(_objectSpread({}, me.propTypes), {}, {
  defaultTime: V.string,
  onChange: V.func
}), wn.defaultProps = {
  defaultTime: ""
};
var vn = N.forwardRef(function (e, t) {
  var _ref38 = Array.isArray(t) ? t : [t],
      _ref39 = _slicedToArray(_ref38, 2),
      r = _ref39[0],
      n = _ref39[1],
      o = e.name,
      a = e.defaultValue,
      l = e.placeholder,
      i = e.rangeSelect,
      s = e.anchor,
      c = e.defaultPopped,
      p = e.onPopped,
      d = e.onChange,
      m = e.disabled,
      u = e.error,
      h = W(null),
      f = W(null),
      g = ze(r, h),
      y = ze(n, f),
      _a = _slicedToArray(a, 2),
      b = _a[0],
      $ = _a[1],
      _I29 = I(bn(b)),
      _I30 = _slicedToArray(_I29, 2),
      x = _I30[0],
      E = _I30[1],
      _I31 = I(bn($)),
      _I32 = _slicedToArray(_I31, 2),
      k = _I32[0],
      w = _I32[1],
      v = l || (i ? ["Start time", "End time"] : "Select a time"),
      T = o || (i ? ["startTime", "endTime"] : "time");

  P(function () {
    x && g && (g.current.value = x), k && y && (y.current.value = k);
  }, [x, k]);

  var C = function C(e, t) {
    t === g ? E(e) : t === y && w(e), d && d(i ? [x, k] : x);
  },
      S = Te(e, le.propTypes),
      O = Te(e, z.propTypes);

  return N.createElement(er, ie({
    anchor: s,
    defaultPopped: c,
    onPopped: p,
    popupWidth: "100%",
    disabled: m
  }, S, {
    menu: N.createElement(me, null, N.createElement(wn, {
      onChange: function onChange(e) {
        return C(e, g);
      },
      defaultTime: x
    }), i && N.createElement(N.Fragment, null, N.createElement(Xe, {
      width: "24px"
    }), N.createElement(wn, {
      onChange: function onChange(e) {
        return C(e, y);
      },
      defaultTime: k
    })))
  }), i ? N.createElement(Be, ie({
    flex: 1,
    ref: [g, y],
    icon: N.createElement(U, {
      icon: ae
    }),
    placeholder: v,
    name: T,
    disabled: m,
    error: u
  }, O)) : N.createElement(qe, ie({
    flex: 1,
    ref: g,
    icon: N.createElement(U, {
      icon: ae
    }),
    placeholder: v,
    name: T,
    disabled: m,
    error: u
  }, O)));
});
vn.displayName = "Timepicker", vn.propTypes = _objectSpread(_objectSpread(_objectSpread({}, le.propTypes), z.propTypes), {}, {
  rangeSelect: V.bool,
  defaultValue: V.array,
  name: V.oneOfType([V.string, V.arrayOf(V.string)]),
  placeholder: V.oneOfType([V.string, V.arrayOf(V.string)]),
  anchor: V.oneOf(["top", "topLeft", "topRight", "bottom", "bottomLeft", "bottomRight"]).isRequired,
  defaultPopped: V.bool,
  onPopped: V.func,
  disabled: V.oneOfType([V.bool, V.arrayOf(V.bool)]),
  error: V.bool
}), vn.defaultProps = {
  anchor: "bottomRight",
  defaultValue: []
};

var Tn = e.code(_templateObject104 || (_templateObject104 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 0.85rem;\n  background-color: #eeeeee;\n"])), D("fonts.monospace", "monospace")),
    Cn = e.pre(_templateObject105 || (_templateObject105 = _taggedTemplateLiteral(["\n  display: block;\n  padding: ", ";\n  background-color: #eeeeee;\n  font-size: 0.85rem;\n  line-height: 1.4;\n"])), D("space.m", "6px")),
    Sn = function Sn(e) {
  return N.createElement(Cn, null, N.createElement(Tn, null, e.children.trim()));
};

Sn.propTypes = {
  children: V.string
};

var On = e(le)(_templateObject106 || (_templateObject106 = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  border-style: solid;\n  border-color: ", ";\n  border-width: ", ";\n  background-color: white;\n  margin-top: ", ";\n  padding: ", ";\n"])), D("radii.s", "4px"), D("colors.secondaryDarkVariant", "blue"), D("borderWidth.surface", "1px"), D("space.l", "1rem"), D("space.m", "8px")),
    zn = function zn(e) {
  return N.createElement(On, e, e.children);
};

zn.propTypes = _objectSpread(_objectSpread({}, le.propTypes), {}, {
  children: V.node
});

var Rn = e(le)(_templateObject107 || (_templateObject107 = _taggedTemplateLiteral(["\n  display: flex;\n  visibility: ", ";\n  flex-direction: row;\n  justify-content: ", ";\n  align-items: stretch;\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  opacity: ", ";\n  transition: all 0.3s;\n  background-color: rgba(0, 0, 0, 0.3);\n"])), function (e) {
  return e.opened ? "visible" : "hidden";
}, function (e) {
  return "left" === e.anchor ? "flex-start" : "flex-end";
}, function (e) {
  return e.opened ? 1 : 0;
}),
    Dn = e(le)(_templateObject108 || (_templateObject108 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  ", "\n  ", "\n  box-shadow: ", ";\n  transition: all 0.3s;\n"])), R("colors.surface"), R("colors.onSurface"), q("anchor", "left")(_templateObject109 || (_templateObject109 = _taggedTemplateLiteral(["\n    margin-left: ", ";\n  "])), function (e) {
  return e.opened ? 0 : "-1000px";
}), q("anchor", "right")(_templateObject110 || (_templateObject110 = _taggedTemplateLiteral(["\n    margin-right: ", ";\n  "])), function (e) {
  return e.opened ? 0 : "-1000px";
}), R("shadows.large")),
    Nn = function Nn(e) {
  var t = e.opened,
      r = e.anchor,
      n = e.onHide,
      o = e.children,
      a = e.width,
      l = ve(e, ["onHide"]);
  return N.createElement(Rn, {
    opened: t,
    anchor: r,
    onMouseDown: function onMouseDown() {
      return n();
    }
  }, N.createElement(Dn, ie({}, l, {
    width: a,
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    }
  }), o));
};

Nn.propTypes = {
  children: V.node,
  anchor: V.oneOf(["left", "right"]),
  opened: V.bool,
  width: le.propTypes.width,
  onHide: V.func.isRequired
}, Nn.defaultProps = {
  anchor: "left",
  width: ["440px", null, null, "600px"]
};

var Pn = e(le)(_templateObject111 || (_templateObject111 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  padding: 2rem 1rem 2rem 0;\n  height: 100%;\n  min-height: 0;\n  overflow-y: auto;\n"]))),
    In = function In(e) {
  var t = ve(e, ["onHide"]);
  return N.createElement(Pn, t, N.createElement(ue, {
    width: "48px",
    justifyContent: "flex-start",
    alignItems: "center"
  }, N.createElement(Oe, {
    variant: "icon",
    onClick: function onClick() {
      return e.onHide();
    },
    fontSize: "28px",
    color: "onSurface"
  }, N.createElement(U, {
    icon: te
  }))), N.createElement(le, {
    flex: 1
  }, e.children));
};

In.propTypes = {
  children: V.node,
  onHide: V.func.isRequired
}, Nn.Menu = In;

var Wn = function Wn(e) {
  var t = e.minWidth,
      r = e.maxWidth,
      n = e.color,
      o = e.bg;
  var a = {
    mx: "auto",
    px: ["s", "m", "l", null],
    minWidth: t
  };
  return r && (a = _objectSpread(_objectSpread({}, e), {}, {
    maxWidth: [null, null, null, r]
  })), N.createElement(le, {
    position: "relative",
    role: "page",
    flex: 1,
    pt: "l",
    pb: "l",
    overflowY: "auto",
    height: "100%",
    color: n,
    bg: o
  }, N.createElement(le, a, e.children));
};

Wn.propTypes = {
  children: V.node,
  minWidth: V.oneOfType([V.number, V.string]),
  maxWidth: V.oneOfType([V.number, V.string]),
  color: V.string,
  bg: V.string
}, Wn.defaultProps = {
  color: "onBackground",
  bg: "background"
};

var Hn = e(le).attrs({
  role: "table"
})(_templateObject112 || (_templateObject112 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: table;\n  border-spacing: 0;\n  border-collapse: collapse;\n  table-layout: ", ";\n"])), function (e) {
  return e.tableLayout || "auto";
}),
    Ln = e(le)(_templateObject113 || (_templateObject113 = _taggedTemplateLiteral(["\n  min-width: auto;\n  text-align: ", ";\n  padding: ", ";\n  font-weight: ", ";\n"])), function (e) {
  return e.textAlign || "left";
}, D("space.m", "12px"), function (e) {
  return e.header ? "700" : "400";
}),
    Mn = e.thead(_templateObject114 || (_templateObject114 = _taggedTemplateLiteral([""]))),
    Fn = e.tbody(_templateObject115 || (_templateObject115 = _taggedTemplateLiteral([""]))),
    Vn = e.tr(_templateObject116 || (_templateObject116 = _taggedTemplateLiteral(["\n  justify-items: stretch;\n  align-items: center;\n  align-content: start;\n  border-width: ", ";\n  border-bottom-style: solid;\n  border-color: ", ";\n"])), D("borders.separator", "1px"), D("colors.border", "#EEEEEE")),
    jn = function jn(e) {
  return N.createElement(Hn, ie({
    as: "table"
  }, e));
};

jn.propTypes = {
  tableLayout: V.oneOf(["inherit", "auto", "fixed"])
}, jn.THead = Mn, jn.TBody = Fn, jn.TR = Vn, jn.TH = function (e) {
  return N.createElement(Ln, ie({
    as: "th",
    header: !0
  }, e));
}, jn.TD = function (e) {
  return N.createElement(Ln, ie({
    as: "td"
  }, e));
};

var qn = e.col(_templateObject117 || (_templateObject117 = _taggedTemplateLiteral(["\n  width: 54px;\n"]))),
    An = jn.TR,
    Bn = jn.TD,
    Un = function Un(e) {
  var t = e.colSpan,
      r = e.customView;
  return N.createElement(An, null, N.createElement(Bn, {
    colSpan: t
  }, r || N.createElement(le, {
    pt: "l",
    pb: "l",
    textAlign: "center"
  }, N.createElement(At.Subtitle2, {
    color: "#C7C7C7"
  }, "No Data"))));
};

Un.propTypes = {
  colSpan: V.number.isRequired,
  customView: V.node
};
var _n = jn.THead,
    Yn = jn.TBody,
    Gn = jn.TR,
    Jn = jn.TH,
    Kn = jn.TD,
    Zn = N.memo(function (e) {
  var t = e.scheme,
      r = e.data,
      n = e.idKey,
      o = e.renderColumn,
      a = e.hideHeader,
      l = e.useCheckbox,
      i = e.defaultCheckedRows,
      s = e.onCheck,
      c = e.emptyView,
      _I33 = I(i),
      _I34 = _slicedToArray(_I33, 2),
      p = _I34[0],
      d = _I34[1],
      m = Te(e, le.propTypes),
      u = t.map(function (e) {
    return e.dataKey;
  }),
      h = function h(e, t) {
    var _t$target = t.target,
        r = _t$target.checked,
        n = _t$target.value,
        o = r ? _toConsumableArray(new Set([].concat(_toConsumableArray(p), [n]))) : p.filter(function (e) {
      return e !== n;
    });
    d(o), s && s(o);
  },
      f = t.length + (l ? 1 : 0);

  return N.createElement(jn, m, N.createElement("colgroup", null, l && N.createElement(qn, null), t.map(function (e, t) {
    return N.createElement("col", {
      key: "col-".concat(e, "-").concat(t)
    });
  })), !a && N.createElement(_n, null, N.createElement(Gn, {
    as: "tr"
  }, l && N.createElement(Jn, {
    textAlign: "center"
  }, N.createElement(le, {
    display: "inline-block"
  }, N.createElement(ft, {
    checked: 0 !== r.length && r.length === p.length,
    onChange: function onChange(e) {
      var t = e ? r.map(function (e) {
        var t;
        return null === (t = e[n]) || void 0 === t ? void 0 : t.toString();
      }) : [];
      d(t), s && s(t);
    }
  }))), t.map(function (e, t) {
    return N.createElement(Jn, {
      key: "hd-".concat(e, "-").concat(t)
    }, e.title);
  }))), N.createElement(Yn, null, r.map(function (e, t) {
    var r = e[n] ? e[n].toString() : "row-" + t;
    return N.createElement(Gn, {
      key: t,
      "data-id": r
    }, l && N.createElement(Kn, {
      textAlign: "center"
    }, N.createElement(le, {
      display: "inline-block"
    }, N.createElement(ft, {
      value: r,
      checked: (a = r, p.indexOf(a) >= 0),
      onChange: h
    }))), u.map(function (t, r) {
      var n = e[t] || null,
          a = o ? o(t, n, e) : n;
      return N.createElement(Kn, {
        key: "dk-" + r
      }, a || "");
    }));
    var a;
  }), (!r || 0 === r.length) && N.createElement(Un, {
    colSpan: f,
    customView: c
  })));
});
Zn.displayName = "DataTable";

var Qn = e($e)(_templateObject118 || (_templateObject118 = _taggedTemplateLiteral(["\n  height: 2rem;\n  margin-right: ", ";\n"])), D("space.m", "4px")),
    Xn = function Xn() {
  return N.createElement(me, {
    mt: "l"
  }, N.createElement(Qn, {
    flex: 2
  }), N.createElement(Qn, {
    flex: 5
  }), N.createElement(Qn, {
    flex: 1
  }), N.createElement(Qn, {
    flex: 1
  }));
};

Zn.skeleton = function (e) {
  var t = Te(e, le.propTypes);
  return N.createElement(le, t, N.createElement(Xn, null), N.createElement(Xn, null), N.createElement(Xn, null), N.createElement(Xn, null), N.createElement(Xn, null));
}, Zn.skeleton.displayName = "DataTable_Skeleton", Zn.propTypes = _objectSpread(_objectSpread({}, le.propTypes), {}, {
  scheme: V.arrayOf(V.shape({
    title: V.string,
    dataKey: V.string
  }).isRequired),
  data: V.array.isRequired,
  idKey: V.string,
  renderColumn: V.func,
  hideHeader: V.bool,
  useCheckbox: V.bool,
  defaultCheckedRows: V.array,
  onCheck: V.func,
  emptyView: V.node
}), Zn.defaultProps = {
  data: [],
  scheme: [],
  idKey: "id",
  defaultCheckedRows: []
};
var eo = e(me)(_templateObject119 || (_templateObject119 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]))),
    to = e(le)(_templateObject120 || (_templateObject120 = _taggedTemplateLiteral(["\n  &:not(:first-child):before {\n    content: '\u203A';\n    margin: 0 0.8rem;\n    opacity: 0.6;\n    font-weight: 700;\n  }\n"])));
eo.Item = to;

var ro = e(de)(_templateObject121 || (_templateObject121 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  user-select: none;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n  border-width: ", ";\n  border-style: solid;\n  border-color: transparent;\n  border-radius: ", ";\n  color: ", ";\n  padding: ", ";\n  text-align: center;\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n  }\n  ", "\n  ", "\n  & + & {\n    margin-left: ", ";\n  }\n"])), R("colors.secondary", "gray"), R("borderWidths.input", "1px"), R("radii.small", "2px"), R("colors.onSecondary", "black"), R("space.s", "4px"), R("colors.onSecondary", "black"), R("colors.secondaryDarkVariant", "darkGray"), j("selected")(_templateObject122 || (_templateObject122 = _taggedTemplateLiteral(["\n    &,&:hover {\n      background-color: ", ";\n      color: ", ";\n      font-weight: bold;\n    }\n  "])), R("colors.primaryLightVariant", "lightBlue"), R("colors.onPrimary", "white")), z, R("space.xs", "4px")),
    no = function no(e) {
  var t = e.direction,
      r = e.children,
      n = e.onChange,
      _e$defaultValue = e.defaultValue,
      o = _e$defaultValue === void 0 ? [] : _e$defaultValue,
      _I35 = I(o),
      _I36 = _slicedToArray(_I35, 2),
      a = _I36[0],
      l = _I36[1];

  P(function () {
    n && n(a);
  }, [a]);
  var i = Te(e, de.propTypes),
      s = Te(e, z.propTypes);
  return N.createElement(de, ie({
    flexDirection: t
  }, i), F.map(r, function (e, t) {
    var r = e.props.value;
    return M(e, _objectSpread({
      key: t,
      onClick: function onClick() {
        return function (e) {
          l(e);
        }(r);
      },
      as: "a",
      selected: r === a
    }, s));
  }));
};

no.displayName = "SingleOptionPicker", no.skeleton = function (e) {
  return N.createElement($e, ie({
    height: "2rem",
    width: "100%"
  }, e, {
    children: null
  }));
}, no.propTypes = _objectSpread({
  direction: V.oneOf(["row", "column"]),
  children: V.node.isRequired,
  onChange: V.func,
  defaultValue: V.oneOfType([V.string, V.number])
}, z.propTypes), no.defaultProps = {
  direction: "row"
}, no.Option = ro;

var oo = e(de)(_templateObject123 || (_templateObject123 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  user-select: none;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n  border-width: ", ";\n  border-style: solid;\n  border-color: transparent;\n  border-radius: ", ";\n  color: ", ";\n  padding: ", ";\n  text-align: center;\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n  }\n  ", "\n  ", "\n  & + & {\n    margin-left: ", ";\n  }\n"])), R("colors.secondary", "gray"), R("borderWidths.input", "1px"), R("radii.small", "2px"), R("colors.onSecondary", "black"), R("space.s", "4px"), R("colors.onSecondary", "black"), R("colors.secondaryDarkVariant", "darkGray"), j("selected")(_templateObject124 || (_templateObject124 = _taggedTemplateLiteral(["\n    &,&:hover {\n      background-color: ", ";\n      color: ", ";\n      font-weight: bold;\n    }\n  "])), R("colors.primaryLightVariant", "lightBlue"), R("colors.onPrimary", "white")), z, R("space.xs", "4px")),
    ao = function ao(e) {
  var t = e.direction,
      r = e.children,
      n = e.onChange,
      _e$defaultValue2 = e.defaultValue,
      o = _e$defaultValue2 === void 0 ? [] : _e$defaultValue2,
      a = e.maxLimit,
      _I37 = I(o),
      _I38 = _slicedToArray(_I37, 2),
      l = _I38[0],
      i = _I38[1];

  P(function () {
    n && n(l);
  }, [l]);
  var s = Te(e, de.propTypes),
      c = Te(e, z.propTypes);
  return N.createElement(de, ie({
    flexDirection: t
  }, s), F.map(r, function (e, t) {
    var r = e.props.value;
    return M(e, _objectSpread({
      key: t,
      onClick: function onClick() {
        return function (e) {
          i(function (t) {
            return t.indexOf(e) >= 0 ? t.filter(function (t) {
              return t !== e;
            }) : a && t.length >= a ? t : [].concat(_toConsumableArray(t), [e]);
          });
        }(r);
      },
      as: "a",
      selected: l.indexOf(r) >= 0
    }, c));
  }));
};

ao.displayName = "MultiOptionPicker", ao.skeleton = function (e) {
  return N.createElement($e, ie({
    height: "2rem",
    width: "100%"
  }, e, {
    children: null
  }));
}, ao.propTypes = _objectSpread({
  direction: V.oneOf(["row", "column"]),
  children: V.node.isRequired,
  onChange: V.func,
  maxLimit: V.number,
  defaultValue: V.arrayOf(V.oneOfType([V.string, V.number]))
}, z.propTypes), ao.defaultProps = {
  direction: "row"
}, ao.Option = oo;

var lo = function lo(e) {
  return N.createElement("form", e);
};

lo.propTypes = {
  onSubmit: V.func.isRequired
};

var io = e(le).attrs(function (_ref40) {
  var e = _ref40.marginTop,
      t = _ref40.mt;
  if (void 0 !== e ? e : void 0 !== t ? t : void 0) return {
    styled: {
      marginTop: e
    }
  };
})(_templateObject125 || (_templateObject125 = _taggedTemplateLiteral(["\n  & + & {\n    margin-top: ", ";\n  }\n"])), D("space.m", "1rem")),
    so = function so(e) {
  var t = e.name,
      r = e.label,
      n = e.errorMessage,
      o = ve(e, ["name", "label", "errorMessage"]);
  return N.createElement(io, o, r && N.createElement(At.Subtitle1, {
    as: "label",
    htmlFor: t,
    mb: "xs"
  }, r), N.createElement(le, null, t ? N.Children.map(e.children, function (e) {
    return N.isValidElement(e) ? N.cloneElement(e, {
      id: t,
      name: t
    }) : e;
  }) : e.children), n && N.createElement(Bt, {
    color: "error"
  }, n));
};

so.displayName = "FormItem", so.propTypes = {
  name: V.oneOfType([V.string, V.arrayOf(V.string)]),
  label: V.oneOfType([V.string, V.node]),
  errorMessage: V.string,
  children: V.node
}, lo.Item = so;
var co = e.hr(_templateObject126 || (_templateObject126 = _taggedTemplateLiteral(["\n", "\n", "\n", "\n"])), q("space", "s")(_templateObject127 || (_templateObject127 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n"])), D("spaces.s", "0.5rem"), D("spaces.s", "0.5rem")), q("space", "m")(_templateObject128 || (_templateObject128 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n"])), D("spaces.m", "1rem"), D("spaces.m", "1rem")), q("space", "l")(_templateObject129 || (_templateObject129 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n"])), D("spaces.l", "1.5rem"), D("spaces.l", "1.5rem")));
co.defaultProps = {
  space: "m"
};

var po = e(le)(_templateObject130 || (_templateObject130 = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin: ", ";\n"])), D("space.l", "8px")),
    mo = e(me)(_templateObject131 || (_templateObject131 = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.3);\n  visibility: ", ";\n  opacity: ", ";\n  transition: all 0.3s;\n"])), function (e) {
  return e.show ? "visible" : "hidden";
}, function (e) {
  return e.show ? 1 : 0;
}),
    uo = function uo(e) {
  var t = e.show,
      r = e.onConfirm,
      n = e.onCancel,
      o = e.confirmLabel,
      a = e.cancelLabel,
      l = e.minWidth,
      i = e.minHeight,
      s = e.maxWidth,
      c = e.maxHeight;
  return N.createElement(mo, {
    show: t
  }, N.createElement(po, null, N.createElement(se, {
    minWidth: l,
    maxWidth: s,
    minHeight: i,
    maxHeight: c
  }, N.createElement(ue, null, N.createElement(le, {
    flex: 1
  }, e.children), N.createElement(me, {
    justifyContent: "flex-end",
    mt: "l"
  }, N.createElement(Qt, null, N.createElement(Oe, {
    variant: "secondary",
    onClick: function onClick() {
      n && n();
    },
    minWidth: "80px"
  }, a), N.createElement(Oe, {
    onClick: function onClick() {
      r && r();
    },
    minWidth: "80px"
  }, o)))))));
};

uo.propTypes = {
  show: V.bool,
  onConfirm: V.func,
  onCancel: V.func,
  children: V.node,
  confirmLabel: V.string,
  cancelLabel: V.string,
  minWidth: V.string,
  minHeight: V.string,
  maxWidth: V.string,
  maxHeight: V.string
}, uo.defaultProps = {
  confirmLabel: "OK",
  cancelLabel: "Cancel",
  minWidth: "240px",
  minHeight: "80px"
};

var ho = e(le)(_templateObject132 || (_templateObject132 = _taggedTemplateLiteral(["\n  flex: 1;\n  min-height: 240px;\n  padding: ", ";\n  border-style: dashed;\n  border-width: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  input[type='file'] {\n    display: none;\n  }\n  svg {\n    transition: all 0.3s;\n  }\n  ", "\n"])), D("space.m", "16px"), D("borderWidths.input", "1px"), D("colors.border"), D("radii.m"), j("highlight")(_templateObject133 || (_templateObject133 = _taggedTemplateLiteral(["\n    border-style: solid;\n    border-color: ", ";\n    svg { \n        color: ", ";\n    }\n  "])), D("colors.primary"), D("colors.primary"))),
    fo = function fo(e) {
  var t = e.disabled,
      r = e.accept,
      n = e.multiple,
      o = e.handleUpload,
      a = W(),
      _I39 = I(!1),
      _I40 = _slicedToArray(_I39, 2),
      l = _I40[0],
      i = _I40[1],
      _I41 = I({
    status: "pending"
  }),
      _I42 = _slicedToArray(_I41, 2),
      s = _I42[0],
      c = _I42[1],
      p = function p() {
    a.current.click();
  },
      d = function d(e) {
    if (o) {
      var _t5 = function (e) {
        var t = [];

        for (var r = 0; r < e.length; r++) {
          t.push(e.item(r));
        }

        return t;
      }(e);

      c({
        status: "uploading",
        data: _t5
      }), o(_t5).then(function () {
        c({
          status: "pending"
        });
      }).catch(function () {
        c({
          status: "pending"
        });
      });
    }
  };

  return N.createElement(ho, {
    onDragOver: function onDragOver(e) {
      e.preventDefault(), t || i(!0);
    },
    onDragLeave: function onDragLeave(e) {
      e.preventDefault(), i(!1);
    },
    onDrop: function onDrop(e) {
      e.preventDefault(), t || (d(event.dataTransfer.files), i(!1));
    },
    highlight: l
  }, N.createElement(ue, {
    alignItems: "center",
    justifyContent: "center"
  }, N.createElement(At.Span, {
    fontSize: "80px",
    color: "#DDD"
  }, N.createElement(U, {
    icon: re
  })), "pending" === s.status && N.createElement(N.Fragment, null, N.createElement(At.Span, null, "Drag and drop files from your computer"), N.createElement(Oe, {
    variant: "secondary",
    mt: "m",
    onClick: p,
    disabled: t
  }, "Choose file")), "uploading" === s.status && ((null === (m = s.data) || void 0 === m ? void 0 : m.length) > 1 ? N.createElement(At.Span, null, "Uploading ", s.data.length, " files") : N.createElement(me, {
    alignItems: "center"
  }, N.createElement(we, {
    size: 20,
    color: "#A9A9A9"
  }), N.createElement(At.Span, {
    ml: "m"
  }, "Uploading ", s.data[0].name)))), N.createElement("input", {
    ref: a,
    className: "FileInput",
    type: "file",
    multiple: n,
    onChange: function onChange(e) {
      t || d(e.target.files);
    },
    accept: r
  }));
  var m;
};

fo.displayName = "Dropzone", fo.propTypes = {
  disabled: V.bool,
  accept: V.string,
  multiple: V.bool,
  handleUpload: V.func
};

var go = e(le)(_templateObject134 || (_templateObject134 = _taggedTemplateLiteral(["\n  position: sticky;\n  position: -webkit-sticky;\n  top: ", ";\n  z-index: ", ";\n"])), function (e) {
  return e.top || 0;
}, function (e) {
  return e.zIndex || 200;
}),
    yo = function yo() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "m";
  var t = 0,
      r = "16px";

  switch (e) {
    case "xs":
      t = "18px", r = "12px";
      break;

    case "s":
      t = "24px", r = "16px";
      break;

    case "l":
      t = "48px", r = "32px";
      break;

    case "xl":
      t = "54px", r = "36px";
      break;

    case "xxl":
      t = "64px", r = "48px";
      break;

    case "m":
    default:
      t = "36px", r = "24px";
  }

  return {
    width: t,
    height: t,
    fontSize: r
  };
},
    bo = e(le)(_templateObject135 || (_templateObject135 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  border-width: 2px;\n  border-style: solid;\n  text-align: center;\n  user-select: none;\n  ", "\n  ", "\n"])), q("variant", "default")(_templateObject136 || (_templateObject136 = _taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n    border-radius: 50%;\n    border-color: ", ";\n    color: ", ";\n    background-color: transparent;\n  "])), function (e) {
  return e.width;
}, function (e) {
  return e.height;
}, R("colors.primary", "blue"), R("colors.primary", "blue")), q("variant", "unread")(_templateObject137 || (_templateObject137 = _taggedTemplateLiteral(["\n    width: auto;\n    height: auto;\n    padding: 0 0.5rem;\n    border-radius: 3rem;\n    letter-spacing: -2px;\n    text-indent: -2px;\n    background-color: #ec407a;\n    color: white;\n  "])))),
    $o = function $o(e) {
  var t = e.size,
      r = _objectSpread(_objectSpread({}, yo(t)), ve(e, ["size"]));

  return N.createElement(bo, r, N.createElement("span", null, e.children));
};

$o.propTypes = {
  size: V.oneOf(["xs", "s", "m", "l", "xl", "xxl"]),
  variant: V.oneOf(["default", "unread"]),
  children: V.node
}, $o.defaultProps = {
  variant: "default"
};

var xo = e.button.attrs(function () {
  return {
    type: "button"
  };
})(_templateObject138 || (_templateObject138 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  color: ", ";\n  font-size: 18px;\n  height: ", ";\n  text-align: center;\n  > * {\n    line-height: 1;\n  }\n"])), D("colors.onPrimary", "#000000"), "50px"),
    Eo = function Eo(e) {
  return N.createElement(ue, {
    width: 50,
    justifyContent: "space-between",
    alignItems: "stretch",
    backgroundColor: "primary"
  }, N.createElement(ue, {
    alignItems: "stretch"
  }, e.menuItems.map(function (e) {
    return N.createElement(xo, {
      key: e.name,
      onClick: e.onClick
    }, e.icon);
  })), N.createElement(ue, {
    alignItems: "stretch"
  }, e.settingItems.map(function (e) {
    var t = e.onClick ? void 0 : "div";
    return N.createElement(xo, {
      as: t,
      key: e.name,
      onClick: e.onClick
    }, e.icon);
  })));
};

Eo.displayName = "NavigationBar", Eo.propTypes = {
  menuItems: V.array.isRequired,
  settingItems: V.array
}, Eo.defaultProps = {
  menuItems: [],
  settingItems: []
};

var ko = e(le).attrs(function () {
  return {
    role: "menu"
  };
})(_templateObject139 || (_templateObject139 = _taggedTemplateLiteral(["\n    height: \"100%\";\n    background-color: ", ";\n    color: ", ";\n    padding: ", ";\n    overflow-y: auto;\n    a {\n      text-decoration: none;\n      border: 0;\n    }\n"])), D("colors.secondary", "transparent"), D("colors.onSecondary", "inherit"), D("space.m", 0)),
    wo = function wo(e) {
  return N.createElement(ko, {
    width: [null, null, 180, 220]
  }, e.children);
};

wo.displayName = "MenuBar", wo.propTypes = {
  children: V.node
};
export { Qe as Avatar, le as Box, eo as Breadcrumb, Oe as Button, sn as Calendar, se as Card, ft as Checkbox, Tn as Code, Sn as CodeBlock, ue as Column, Zn as DataTable, cn as Datepicker, Nn as Drawer, tr as Dropdown, fo as Dropzone, Wn as FixedPage, de as Flex, lo as Form, he as Grid, _e as Image, Qt as InputGroup, Ue as Link, ot as List, wo as MenuBar, uo as Modal, ao as MultiOptionPicker, Eo as NavigationBar, zn as NoteBlock, Gt as NotificationContext, Jt as NotificationProvider, $o as NumberBadge, er as Popover, Cn as Pre, Ir as Radio, me as Row, vr as Select, co as Separator, no as SingleOptionPicker, $e as Skeleton, be as SkeletonBase, ge as Skeletonizer, Xe as Spacer, Bt as Span, we as Spinner, go as StickyBox, jn as Table, ur as Tag, hr as TagGroup, qe as TextInput, Be as TextRangeInput, wn as TimeInput, $n as TimeUtil, vn as Timepicker, wt as Tree, At as Typography, Ie as useColorPalette, ze as useCombinedRefs, We as useMouseEvent, Kt as useNotification, ve as usePropsExclude, Te as usePropsFilter, Ne as useRangeReducer, Me as useServiceWorker };